import * as ui from "../native";
import React, { ReactNode } from "react";
import { DomUtils } from "../utils/DomUtils";
import { BuildContext } from "../classes/BuildContext";

export class StyleThemeData {
  public readonly themeName: string;
  public readonly color: ui.Color;
  public readonly textStyle: ui.TextStyle;
  public readonly tooltipBackgroundColor: ui.Color;
  public readonly tooltipTextColor: ui.Color;
  public static DarkTheme: StyleThemeData;
  public static LightTheme: StyleThemeData;
  public readonly c1: ui.Color;
  public readonly c2: ui.Color;
  public readonly c3: ui.Color;
  public readonly c4: ui.Color;
  public readonly c5: ui.Color;
  public readonly c6: ui.Color;
  public readonly c7: ui.Color;
  public readonly c8: ui.Color;
  public readonly c9: ui.Color;
  public readonly c10: ui.Color;
  public readonly c11: ui.Color;
  public readonly c12: ui.Color;
  public readonly c13: ui.Color;
  public readonly c14: ui.Color;
  public readonly c15: ui.Color;
  public readonly c16: ui.Color;
  public readonly c17: ui.Color;
  public readonly tTableRowTableBackgroundDecorationOn: ui.BoxDecoration;
  public readonly tTableRowTableBackgroundPaddingOn: ui.EdgeInsets;
  public readonly tTableRowTableBackgroundTextStyleOn: ui.TextStyle;
  public readonly tTableRowTableBackgroundConstraintsOn: ui.BoxConstraints;
  public readonly tTableCellDefaultCellVerticalAlignmentOn: ui.TableCellVerticalAlignment;
  public readonly tTableDefaultTableBorderOn: ui.TableBorder;
  public readonly tButtonButtonWithNoBorderRadiusDecorationOn: ui.BoxDecoration;
  public readonly tButtonButtonWithNoBorderRadiusHeightOn: number;
  public readonly tButtonButtonWithNoBorderRadiusConstraintsOn: ui.BoxConstraints;
  public readonly tButtonButtonWithNoBorderRadiusTextStyleOn: ui.TextStyle;
  public readonly tButtonButtonWithNoBorderRadiusDecorationOnHover: ui.BoxDecoration;
  public readonly tButtonButtonWithNoBorderRadiusTextStyleOnHover: ui.TextStyle;
  public readonly tButtonButtonWithNoBorderRadiusDecorationOnFocus: ui.BoxDecoration;
  public readonly tButtonButtonWithNoBorderRadiusTextStyleOnFocus: ui.TextStyle;
  public readonly tButtonPrimaryButtonDecorationOn: ui.BoxDecoration;
  public readonly tButtonPrimaryButtonPaddingOn: ui.EdgeInsets;
  public readonly tButtonPrimaryButtonConstraintsOn: ui.BoxConstraints;
  public readonly tButtonPrimaryButtonTextStyleOn: ui.TextStyle;
  public readonly tButtonPrimaryButtonDecorationOnHover: ui.BoxDecoration;
  public readonly tButtonPrimaryButtonTextStyleOnHover: ui.TextStyle;
  public readonly tButtonPrimaryButtonDecorationOnFocus: ui.BoxDecoration;
  public readonly tButtonPrimaryButtonTextStyleOnFocus: ui.TextStyle;
  public readonly tButtonDisabledPrimaryButtonDecorationOn: ui.BoxDecoration;
  public readonly tButtonDisabledPrimaryButtonPaddingOn: ui.EdgeInsets;
  public readonly tButtonDisabledPrimaryButtonConstraintsOn: ui.BoxConstraints;
  public readonly tButtonDisabledPrimaryButtonTextStyleOn: ui.TextStyle;
  public readonly tButtonSecondaryButtonPaddingOn: ui.EdgeInsets;
  public readonly tButtonSecondaryButtonConstraintsOn: ui.BoxConstraints;
  public readonly tButtonSecondaryButtonDecorationOn: ui.BoxDecoration;
  public readonly tButtonSecondaryButtonTextStyleOn: ui.TextStyle;
  public readonly tButtonSecondaryButtonDecorationOnHover: ui.BoxDecoration;
  public readonly tButtonSecondaryButtonTextStyleOnHover: ui.TextStyle;
  public readonly tButtonSecondaryButtonDecorationOnFocus: ui.BoxDecoration;
  public readonly tButtonSecondaryButtonTextStyleOnFocus: ui.TextStyle;
  public readonly tButtonAddButtonDecorationOn: ui.BoxDecoration;
  public readonly tButtonAddButtonTextStyleOn: ui.TextStyle;
  public readonly tButtonAddButtonHeightOn: number;
  public readonly tButtonAddButtonPaddingOn: ui.EdgeInsets;
  public readonly tButtonAddButtonConstraintsOn: ui.BoxConstraints;
  public readonly tButtonAddButtonDecorationOnHover: ui.BoxDecoration;
  public readonly tButtonAddButtonTextStyleOnHover: ui.TextStyle;
  public readonly tButtonAddButtonDecorationOnFocus: ui.BoxDecoration;
  public readonly tButtonAddButtonTextStyleOnFocus: ui.TextStyle;
  public readonly tButtonDeleteButtonDecorationOnHover: ui.BoxDecoration;
  public readonly tButtonDeleteButtonTextStyleOnHover: ui.TextStyle;
  public readonly tButtonDeleteButtonDecorationOn: ui.BoxDecoration;
  public readonly tButtonDeleteButtonPaddingOn: ui.EdgeInsets;
  public readonly tButtonDeleteButtonConstraintsOn: ui.BoxConstraints;
  public readonly tButtonDeleteButtonTextStyleOn: ui.TextStyle;
  public readonly tButtonDeleteButtonDecorationOnFocus: ui.BoxDecoration;
  public readonly tButtonDeleteButtonTextStyleOnFocus: ui.TextStyle;
  public readonly tTextViewListTileTextFontSizeOn: number;
  public readonly tTextViewListTileTextFontWeightOn: ui.FontWeight;
  public readonly tTextViewListTileTextColorOn: ui.Color;
  public readonly tTextViewListTileTextOverflowOn: ui.TextOverflow;
  public readonly tTextViewListTileTextOnLightBackgroundFontSizeOn: number;
  public readonly tTextViewListTileTextOnLightBackgroundFontWeightOn: ui.FontWeight;
  public readonly tTextViewListTileTextOnLightBackgroundColorOn: ui.Color;
  public readonly tTextViewBoldHeadingFontSizeOn: number;
  public readonly tTextViewBoldHeadingFontWeightOn: ui.FontWeight;
  public readonly tTextViewBoldHeadingColorOn: ui.Color;
  public readonly tTextViewBoldHeadingPaddingOn: ui.EdgeInsets;
  public readonly tTextViewHeadingFontSizeOn: number;
  public readonly tTextViewHeadingFontWeightOn: ui.FontWeight;
  public readonly tTextViewHeadingTextAlignOn: ui.TextAlign;
  public readonly tTextViewHeadingColorOn: ui.Color;
  public readonly tTextViewParagraphHeadingFontSizeOn: number;
  public readonly tTextViewParagraphHeadingFontWeightOn: ui.FontWeight;
  public readonly tTextViewParagraphHeadingTextAlignOn: ui.TextAlign;
  public readonly tTextViewParagraphHeadingColorOn: ui.Color;
  public readonly tTextViewParagraphHeadingPaddingOn: ui.EdgeInsets;
  public readonly tCheckboxActiveCheckboxActiveColorOn: ui.Color;
  public readonly tIconButtonIconButtonDefaultColorOn: ui.Color;
  public readonly tIconButtonIconButtonDefaultHoverColorOn: ui.Color;
  public readonly tIconViewIconViewDefaultColorOn: ui.Color;
  public readonly tIconViewIconViewDefaultColorOnHover: ui.Color;
  public readonly tIconViewIconViewDefaultColorOnFocus: ui.Color;
  public readonly tTextViewTitleFontSizeOn: number;
  public readonly tTextViewTitleColorOn: ui.Color;
  public readonly tTextViewTitleFontWeightOn: ui.FontWeight;
  public readonly tTextViewTitleTextAlignOn: ui.TextAlign;
  public readonly tRowSuccessBackgroundDecorationOn: ui.BoxDecoration;
  public readonly tRowSuccessBackgroundPaddingOn: ui.EdgeInsets;
  public readonly tTextViewSuccessErrorTextFontSizeOn: number;
  public readonly tTextViewSuccessErrorTextTextAlignOn: ui.TextAlign;
  public readonly tTextViewSuccessErrorTextColorOn: ui.Color;
  public readonly tTextViewErrorMessageColorOn: ui.Color;
  public readonly tTextViewErrorMessageFontSizeOn: number;
  public readonly tTextViewErrorMessageTextAlignOn: ui.TextAlign;
  public readonly tTextViewListTextFontSizeOn: number;
  public readonly tTextViewListTextColorOn: ui.Color;
  public readonly tTextViewListTextTextAlignOn: ui.TextAlign;
  public readonly tTextViewListTextOverflowOn: ui.TextOverflow;
  public readonly tTextViewLabelTextColorOn: ui.Color;
  public readonly tTextViewLabelTextTextAlignOn: ui.TextAlign;
  public readonly tTextViewLabelTextFontSizeOn: number;
  public readonly tTextViewLabelTextFontWeightOn: ui.FontWeight;
  public readonly tBaseBackgroundColorDecorationOn: ui.BoxDecoration;
  public readonly tBaseBackgroundColorColumnDecorationOn: ui.BoxDecoration;
  public readonly tBaseBackgroundColorColumnPaddingOn: ui.EdgeInsets;
  public readonly tTextViewParagraphTextFontSizeOn: number;
  public readonly tTextViewParagraphTextFontWeightOn: ui.FontWeight;
  public readonly tTextViewParagraphTextColorOn: ui.Color;
  public readonly tTextViewColoredTextColorOn: ui.Color;
  public readonly tTextViewColoredTextFontSizeOn: number;
  public readonly tTextViewColoredTextTextDecorationOnHover: ui.TextDecoration;
  public readonly tTextViewParagraphCenterFontSizeOn: number;
  public readonly tTextViewParagraphCenterTextAlignOn: ui.TextAlign;
  public readonly tTextViewParagraphCenterColorOn: ui.Color;
  public readonly tTextViewParagraphCenterPaddingOn: ui.EdgeInsets;
  public readonly tTextViewTextOverFlowFontSizeOn: number;
  public readonly tTextViewTextOverFlowMaxLinesOn: number;
  public readonly tTextViewTextOverFlowTextAlignOn: ui.TextAlign;
  public readonly tTextViewTextOverFlowOverflowOn: ui.TextOverflow;
  public readonly tInputFieldNormalInputfieldHeightOn: number;
  public readonly tInputFieldNormalInputfieldWidthOn: number;
  public readonly tInputFieldNormalInputfieldBackgroundColorOn: ui.Color;
  public readonly tInputFieldNormalInputfieldCornerRadiusOn: number;
  public readonly tInputFieldNormalInputfieldCursorColorOn: ui.Color;
  public readonly tInputFieldNormalInputfieldInActiveColorOn: ui.Color;
  public readonly tInputFieldNormalInputfieldPlaceHolderColorOn: ui.Color;
  public readonly tInputFieldNormalInputfieldStyleOn: ui.TextStyle;
  public readonly tInputFieldSmallNormalInputfieldHeightOn: number;
  public readonly tInputFieldSmallNormalInputfieldWidthOn: number;
  public readonly tInputFieldSmallNormalInputfieldBackgroundColorOn: ui.Color;
  public readonly tInputFieldSmallNormalInputfieldCornerRadiusOn: number;
  public readonly tInputFieldSmallNormalInputfieldCursorColorOn: ui.Color;
  public readonly tInputFieldSmallNormalInputfieldInActiveColorOn: ui.Color;
  public readonly tInputFieldSmallNormalInputfieldPlaceHolderColorOn: ui.Color;
  public readonly tInputFieldSmallNormalInputfieldStyleOn: ui.TextStyle;
  public readonly tInputFieldTestDataInputfieldHeightOn: number;
  public readonly tInputFieldTestDataInputfieldWidthOn: number;
  public readonly tInputFieldTestDataInputfieldBackgroundColorOn: ui.Color;
  public readonly tInputFieldTestDataInputfieldCornerRadiusOn: number;
  public readonly tInputFieldTestDataInputfieldCursorColorOn: ui.Color;
  public readonly tInputFieldTestDataInputfieldStyleOn: ui.TextStyle;
  public readonly tInputFieldDisabledInputfieldWidthOn: number;
  public readonly tInputFieldDisabledInputfieldHeightOn: number;
  public readonly tInputFieldDisabledInputfieldBackgroundColorOn: ui.Color;
  public readonly tInputFieldDisabledInputfieldStyleOn: ui.TextStyle;
  public readonly tInputFieldDisabledInputfieldDisableOn: boolean;
  public readonly tInputFieldDisabledInputfieldDecorationOn: ui.BoxDecoration;
  public readonly tInputFieldSmallDisabledInputfieldWidthOn: number;
  public readonly tInputFieldSmallDisabledInputfieldHeightOn: number;
  public readonly tInputFieldSmallDisabledInputfieldBackgroundColorOn: ui.Color;
  public readonly tInputFieldSmallDisabledInputfieldStyleOn: ui.TextStyle;
  public readonly tInputFieldSmallDisabledInputfieldDisableOn: boolean;
  public readonly tInputFieldSmallDisabledInputfieldDecorationOn: ui.BoxDecoration;
  public readonly tInputFieldSearchInputfieldInActiveColorOn: ui.Color;
  public readonly tInputFieldSearchInputfieldPlaceHolderColorOn: ui.Color;
  public readonly tInputFieldSearchInputfieldActiveColorOn: ui.Color;
  public readonly tInputFieldSearchInputfieldPaddingOn: ui.EdgeInsets;
  public readonly tInputFieldDescriptionInputfieldHeightOn: number;
  public readonly tInputFieldDescriptionInputfieldWidthOn: number;
  public readonly tInputFieldDescriptionInputfieldCornerRadiusOn: number;
  public readonly tInputFieldDescriptionInputfieldBackgroundColorOn: ui.Color;
  public readonly tInputFieldDescriptionInputfieldPlaceHolderColorOn: ui.Color;
  public readonly tInputFieldDescriptionInputfieldStyleOn: ui.TextStyle;
  public readonly tBasePanelColorWithBorderDecorationOn: ui.BoxDecoration;
  public readonly tTextViewDropDownBuilderTextColorOn: ui.Color;
  public readonly tTextViewDropDownBuilderTextPaddingOn: ui.EdgeInsets;
  public readonly tDropDownRoundRadiusDropDownHeightOn: number;
  public readonly tDropDownRoundRadiusDropDownOnHoverColorOn: ui.Color;
  public readonly tDropDownRoundRadiusDropDownPlaceHolderColorOn: ui.Color;
  public readonly tDropDownRoundRadiusDropDownDropDownDecorationOn: ui.BoxDecoration;
  public readonly tDropDownRoundRadiusDropDownViewDecorationOn: ui.BoxDecoration;
  public readonly tBasePrimaryListTileDecorationOn: ui.BoxDecoration;
  public readonly tBasePrimaryListTileTextStyleOn: ui.TextStyle;
  public readonly tBasePrimaryListTileDecorationOnHover: ui.BoxDecoration;
  public readonly tBasePrimaryListTileTextStyleOnHover: ui.TextStyle;
  public readonly tBasePrimaryListTileDecorationOnFocus: ui.BoxDecoration;
  public readonly tBasePrimaryListTileDecorationOnSelected: ui.BoxDecoration;
  public readonly tBasePrimaryListTileTextStyleOnSelected: ui.TextStyle;
  public readonly tBasePrimaryListTileDecorationOnHoverSelected: ui.BoxDecoration;
  public readonly tBasePrimaryListTileTextStyleOnHoverSelected: ui.TextStyle;
  public readonly tBaseExpEditorStyleDecorationOn: ui.BoxDecoration;
  public readonly tBaseDarkBackgroundDecorationOn: ui.BoxDecoration;
  public readonly tBaseDarkBackgroundTextStyleOn: ui.TextStyle;
  public readonly tContainerLinearGradiantWidthOn: number;
  public readonly tContainerLinearGradiantHeightOn: number;
  public readonly tContainerLinearGradiantDecorationOn: ui.BoxDecoration;
  public readonly tBaseSweepGradiantWidthOn: number;
  public readonly tBaseSweepGradiantHeightOn: number;
  public readonly tBaseSweepGradiantDecorationOn: ui.BoxDecoration;
  public readonly tContainerRadiualGradiantWidthOn: number;
  public readonly tContainerRadiualGradiantHeightOn: number;
  public readonly tContainerRadiualGradiantDecorationOn: ui.BoxDecoration;
  public readonly tButtonUnderlineButtonTextStyleOn: ui.TextStyle;
  public readonly tButtonUnderlineButtonTextStyleOnHover: ui.TextStyle;
  public readonly tButtonUnderlineButtonTextStyleOnFocusHover: ui.TextStyle;
  public readonly tButtonUnderlineButtonDecorationOnFocus: ui.BoxDecoration;
  public readonly tButtonUnderlineButtonTextStyleOnFocus: ui.TextStyle;
  public readonly tButtonBoldUnderlineButtonTextStyleOn: ui.TextStyle;
  public readonly tButtonBoldUnderlineButtonTextStyleOnHover: ui.TextStyle;
  public readonly tButtonBoldUnderlineButtonTextStyleOnFocus: ui.TextStyle;
  public readonly tButtonBoldUnderlineButtonTextStyleOnFocusHover: ui.TextStyle;
  public readonly tSearchComponentSearchFieldDecorationOn: ui.BoxDecoration;
  public readonly tSearchComponentSearchFieldDecorationOnFocus: ui.BoxDecoration;
  public readonly tCheckboxWithTextActiveCheckboxWithTextActiveColorOn: ui.Color;
  public readonly tDoubleInputFieldTestDoubleInputFieldHeightOn: number;
  public readonly tDoubleInputFieldTestDoubleInputFieldWidthOn: number;
  public readonly tDoubleInputFieldTestDoubleInputFieldBackgroundColorOn: ui.Color;
  public readonly tDoubleInputFieldTestDoubleInputFieldCornerRadiusOn: number;
  public readonly tIntegerInputFieldTestIntegerInputFieldHeightOn: number;
  public readonly tIntegerInputFieldTestIntegerInputFieldWidthOn: number;
  public readonly tIntegerInputFieldTestIntegerInputFieldBackgroundColorOn: ui.Color;
  public readonly tIntegerInputFieldTestIntegerInputFieldCornerRadiusOn: number;
  public readonly tAutoSearchTextWithBuilderAutoRoundRadiusDropDownHeightOn: number;
  public readonly tAutoSearchTextWithBuilderAutoRoundRadiusDropDownViewDecorationOn: ui.BoxDecoration;
  public readonly tAutoSearchTextWithBuilderAutoRoundRadiusDropDownDecorationOn: ui.BoxDecoration;
  public readonly tInputFieldInputBasicBackgroundColorOn: ui.Color;
  public readonly tInputFieldInputBasicCornerRadiusOn: number;
  public readonly tInputFieldInputBasicDecorationOn: ui.BoxDecoration;
  public readonly tInputFieldFixedInputFieldBackgroundColorOn: ui.Color;
  public readonly tInputFieldFixedInputFieldCornerRadiusOn: number;
  public readonly tInputFieldFixedInputFieldDecorationOn: ui.BoxDecoration;
  public readonly tBaseCardDecorationOn: ui.BoxDecoration;
  public readonly tBaseDefaultPopUpDecorationOn: ui.BoxDecoration;
  public readonly tTextViewCollapsableHeaderTextColorOn: ui.Color;
  public readonly tTextViewCollapsableHeaderTextFontSizeOn: number;
  public readonly tTextViewCollapsableHeaderTextFontWeightOn: ui.FontWeight;
  public readonly tBaseToolTipDecorationDecorationOn: ui.BoxDecoration;
  public readonly tBaseToolTipDecorationPaddingOn: ui.EdgeInsets;
  public readonly tBaseToolTipDecorationTextStyleOn: ui.TextStyle;
  public readonly tTableRowTableRowHeadingDecorationOn: ui.BoxDecoration;
  public readonly tBaseBackgroundColorColumn2DecorationOn: ui.BoxDecoration;
  public readonly tBaseBackgroundColorColumn2PaddingOn: ui.EdgeInsets;
  public readonly tEditTextFieldNormalEditTextFieldHeightOn: number;
  public readonly tEditTextFieldNormalEditTextFieldWidthOn: number;
  public readonly tEditTextFieldNormalEditTextFieldDecorationOn: ui.BoxDecoration;
  public readonly tCheckboxWitheLabelActiveCheckboxWithLabelActiveColorOn: ui.Color;
  public readonly tContainerDropAreaHeightOn: number;
  public readonly tContainerDropAreaHeightOnHover: number;
  public readonly tContainerDropAreaDecorationOnHover: ui.BoxDecoration;
  public readonly tBaseSelectedTabContainerHeightOn: number;
  public readonly tBaseSelectedTabContainerWidthOn: number;
  public readonly tBaseSelectedTabContainerDecorationOn: ui.BoxDecoration;
  public readonly tTextViewTabsFontSizeOn: number;
  public readonly tTextViewTabsFontWeightOn: ui.FontWeight;
  public readonly tRowChatBoxDecorationOn: ui.BoxDecoration;
  public readonly tRowChatBoxPaddingOn: ui.EdgeInsets;
  public readonly tColumnTemplateCardPaddingOn: ui.EdgeInsets;
  public readonly tColumnTemplateCardDecorationOn: ui.BoxDecoration;
  public readonly tButtonBtnLinkDecorationOn: ui.BoxDecoration;
  public readonly tButtonBtnLinkTextStyleOn: ui.TextStyle;
  public readonly tButtonBtnLinkTextStyleOnHover: ui.TextStyle;
  public readonly tTextViewHeadlineThreeFontSizeOn: number;
  public readonly tTextViewHeadlineThreeFontWeightOn: ui.FontWeight;
  public readonly tTextViewLabelColorOn: ui.Color;
  public readonly tTextViewLabelTextAlignOn: ui.TextAlign;
  public readonly tTextViewLabelMarginOn: ui.EdgeInsets;
  public readonly tButtonOutlineButtonDecorationOn: ui.BoxDecoration;
  public readonly tButtonOutlineButtonTextStyleOn: ui.TextStyle;
  public readonly tButtonOutlineButtonPaddingOn: ui.EdgeInsets;
  public readonly tTextViewErrorLabelColorOn: ui.Color;
  public readonly tTextViewErrorLabelFontFamilyOn: string;
  public readonly tTextViewErrorLabelFontSizeOn: number;
  public readonly tTextViewErrorLabelMarginOn: ui.EdgeInsets;
  public readonly tButtonNewResponceOptionButtonDecorationOn: ui.BoxDecoration;
  public readonly tButtonNewResponceOptionButtonTextStyleOn: ui.TextStyle;
  public readonly tButtonNewResponceOptionButtonTextStyleOnHover: ui.TextStyle;
  public readonly tButtonPrimaryNewDecorationOn: ui.BoxDecoration;
  public readonly tButtonPrimaryNewPaddingOn: ui.EdgeInsets;
  public readonly tButtonPrimaryNewTextStyleOn: ui.TextStyle;
  public readonly tButtonPrimaryNewDecorationOnHover: ui.BoxDecoration;
  public readonly tButtonPrimaryNewPaddingOnHover: ui.EdgeInsets;
  public readonly tButtonPrimaryNewTextStyleOnHover: ui.TextStyle;
  public readonly tButtonResponceOptionButtonPaddingOn: ui.EdgeInsets;
  public readonly tButtonResponceOptionButtonDecorationOn: ui.BoxDecoration;
  public readonly tButtonResponceOptionButtonTextStyleOn: ui.TextStyle;
  public readonly tButtonResponceOptionButtonDecorationOnHover: ui.BoxDecoration;
  public readonly tButtonResponceOptionButtonPaddingOnHover: ui.EdgeInsets;
  public readonly tButtonResponceOptionButtonTextStyleOnHover: ui.TextStyle;
  public readonly tButtonSecondaryDecorationOn: ui.BoxDecoration;
  public readonly tButtonSecondaryPaddingOn: ui.EdgeInsets;
  public readonly tButtonSecondaryConstraintsOn: ui.BoxConstraints;
  public readonly tButtonSecondaryTextStyleOn: ui.TextStyle;
  public readonly tButtonSecondaryDecorationOnHover: ui.BoxDecoration;
  public readonly tButtonSecondaryPaddingOnHover: ui.EdgeInsets;
  public readonly tButtonSecondaryConstraintsOnHover: ui.BoxConstraints;
  public readonly tButtonSecondaryTextStyleOnHover: ui.TextStyle;
  public readonly tButtonSecondaryNewPaddingOn: ui.EdgeInsets;
  public readonly tButtonSecondaryNewDecorationOn: ui.BoxDecoration;
  public readonly tButtonSecondaryNewTextStyleOn: ui.TextStyle;
  public readonly tButtonSecondaryNewDecorationOnHover: ui.BoxDecoration;
  public readonly tButtonSecondaryNewPaddingOnHover: ui.EdgeInsets;
  public readonly tButtonSecondaryNewTextStyleOnHover: ui.TextStyle;
  public readonly tTextViewTableCellTextFontSizeOn: number;
  public readonly tTextViewTableCellTextColorOn: ui.Color;
  public readonly tTextViewTableCellTextFontFamilyOn: string;
  public readonly tTextViewTableHeaderFontSizeOn: number;
  public readonly tTextViewTableHeaderColorOn: ui.Color;
  public readonly tTextViewTableHeaderFontFamilyOn: string;
  public readonly tTableRowTableRowOnebgDecorationOn: ui.BoxDecoration;
  public readonly tTableRowTableRowOnebgPaddingOn: ui.EdgeInsets;
  public readonly tTableRowTableRowTwobgDecorationOn: ui.BoxDecoration;
  public readonly tTableRowTableRowTwobgPaddingOn: ui.EdgeInsets;
  public static current: StyleThemeData;
  public constructor(
    d3eParams?: Partial<{
      themeName: string;
      color: ui.Color;
      textStyle: ui.TextStyle;
      tooltipBackgroundColor: ui.Color;
      tooltipTextColor: ui.Color;
      tTableRowTableBackgroundDecorationOn: ui.BoxDecoration;
      tTableRowTableBackgroundPaddingOn: ui.EdgeInsets;
      tTableRowTableBackgroundTextStyleOn: ui.TextStyle;
      tTableRowTableBackgroundConstraintsOn: ui.BoxConstraints;
      tTableCellDefaultCellVerticalAlignmentOn: ui.TableCellVerticalAlignment;
      tTableDefaultTableBorderOn: ui.TableBorder;
      tButtonButtonWithNoBorderRadiusDecorationOn: ui.BoxDecoration;
      tButtonButtonWithNoBorderRadiusHeightOn: number;
      tButtonButtonWithNoBorderRadiusConstraintsOn: ui.BoxConstraints;
      tButtonButtonWithNoBorderRadiusTextStyleOn: ui.TextStyle;
      tButtonButtonWithNoBorderRadiusDecorationOnHover: ui.BoxDecoration;
      tButtonButtonWithNoBorderRadiusTextStyleOnHover: ui.TextStyle;
      tButtonButtonWithNoBorderRadiusDecorationOnFocus: ui.BoxDecoration;
      tButtonButtonWithNoBorderRadiusTextStyleOnFocus: ui.TextStyle;
      tButtonPrimaryButtonDecorationOn: ui.BoxDecoration;
      tButtonPrimaryButtonPaddingOn: ui.EdgeInsets;
      tButtonPrimaryButtonConstraintsOn: ui.BoxConstraints;
      tButtonPrimaryButtonTextStyleOn: ui.TextStyle;
      tButtonPrimaryButtonDecorationOnHover: ui.BoxDecoration;
      tButtonPrimaryButtonTextStyleOnHover: ui.TextStyle;
      tButtonPrimaryButtonDecorationOnFocus: ui.BoxDecoration;
      tButtonPrimaryButtonTextStyleOnFocus: ui.TextStyle;
      tButtonDisabledPrimaryButtonDecorationOn: ui.BoxDecoration;
      tButtonDisabledPrimaryButtonPaddingOn: ui.EdgeInsets;
      tButtonDisabledPrimaryButtonConstraintsOn: ui.BoxConstraints;
      tButtonDisabledPrimaryButtonTextStyleOn: ui.TextStyle;
      tButtonSecondaryButtonPaddingOn: ui.EdgeInsets;
      tButtonSecondaryButtonConstraintsOn: ui.BoxConstraints;
      tButtonSecondaryButtonDecorationOn: ui.BoxDecoration;
      tButtonSecondaryButtonTextStyleOn: ui.TextStyle;
      tButtonSecondaryButtonDecorationOnHover: ui.BoxDecoration;
      tButtonSecondaryButtonTextStyleOnHover: ui.TextStyle;
      tButtonSecondaryButtonDecorationOnFocus: ui.BoxDecoration;
      tButtonSecondaryButtonTextStyleOnFocus: ui.TextStyle;
      tButtonAddButtonDecorationOn: ui.BoxDecoration;
      tButtonAddButtonTextStyleOn: ui.TextStyle;
      tButtonAddButtonHeightOn: number;
      tButtonAddButtonPaddingOn: ui.EdgeInsets;
      tButtonAddButtonConstraintsOn: ui.BoxConstraints;
      tButtonAddButtonDecorationOnHover: ui.BoxDecoration;
      tButtonAddButtonTextStyleOnHover: ui.TextStyle;
      tButtonAddButtonDecorationOnFocus: ui.BoxDecoration;
      tButtonAddButtonTextStyleOnFocus: ui.TextStyle;
      tButtonDeleteButtonDecorationOnHover: ui.BoxDecoration;
      tButtonDeleteButtonTextStyleOnHover: ui.TextStyle;
      tButtonDeleteButtonDecorationOn: ui.BoxDecoration;
      tButtonDeleteButtonPaddingOn: ui.EdgeInsets;
      tButtonDeleteButtonConstraintsOn: ui.BoxConstraints;
      tButtonDeleteButtonTextStyleOn: ui.TextStyle;
      tButtonDeleteButtonDecorationOnFocus: ui.BoxDecoration;
      tButtonDeleteButtonTextStyleOnFocus: ui.TextStyle;
      tTextViewListTileTextFontSizeOn: number;
      tTextViewListTileTextFontWeightOn: ui.FontWeight;
      tTextViewListTileTextColorOn: ui.Color;
      tTextViewListTileTextOverflowOn: ui.TextOverflow;
      tTextViewListTileTextOnLightBackgroundFontSizeOn: number;
      tTextViewListTileTextOnLightBackgroundFontWeightOn: ui.FontWeight;
      tTextViewListTileTextOnLightBackgroundColorOn: ui.Color;
      tTextViewBoldHeadingFontSizeOn: number;
      tTextViewBoldHeadingFontWeightOn: ui.FontWeight;
      tTextViewBoldHeadingColorOn: ui.Color;
      tTextViewBoldHeadingPaddingOn: ui.EdgeInsets;
      tTextViewHeadingFontSizeOn: number;
      tTextViewHeadingFontWeightOn: ui.FontWeight;
      tTextViewHeadingTextAlignOn: ui.TextAlign;
      tTextViewHeadingColorOn: ui.Color;
      tTextViewParagraphHeadingFontSizeOn: number;
      tTextViewParagraphHeadingFontWeightOn: ui.FontWeight;
      tTextViewParagraphHeadingTextAlignOn: ui.TextAlign;
      tTextViewParagraphHeadingColorOn: ui.Color;
      tTextViewParagraphHeadingPaddingOn: ui.EdgeInsets;
      tCheckboxActiveCheckboxActiveColorOn: ui.Color;
      tIconButtonIconButtonDefaultColorOn: ui.Color;
      tIconButtonIconButtonDefaultHoverColorOn: ui.Color;
      tIconViewIconViewDefaultColorOn: ui.Color;
      tIconViewIconViewDefaultColorOnHover: ui.Color;
      tIconViewIconViewDefaultColorOnFocus: ui.Color;
      tTextViewTitleFontSizeOn: number;
      tTextViewTitleColorOn: ui.Color;
      tTextViewTitleFontWeightOn: ui.FontWeight;
      tTextViewTitleTextAlignOn: ui.TextAlign;
      tRowSuccessBackgroundDecorationOn: ui.BoxDecoration;
      tRowSuccessBackgroundPaddingOn: ui.EdgeInsets;
      tTextViewSuccessErrorTextFontSizeOn: number;
      tTextViewSuccessErrorTextTextAlignOn: ui.TextAlign;
      tTextViewSuccessErrorTextColorOn: ui.Color;
      tTextViewErrorMessageColorOn: ui.Color;
      tTextViewErrorMessageFontSizeOn: number;
      tTextViewErrorMessageTextAlignOn: ui.TextAlign;
      tTextViewListTextFontSizeOn: number;
      tTextViewListTextColorOn: ui.Color;
      tTextViewListTextTextAlignOn: ui.TextAlign;
      tTextViewListTextOverflowOn: ui.TextOverflow;
      tTextViewLabelTextColorOn: ui.Color;
      tTextViewLabelTextTextAlignOn: ui.TextAlign;
      tTextViewLabelTextFontSizeOn: number;
      tTextViewLabelTextFontWeightOn: ui.FontWeight;
      tBaseBackgroundColorDecorationOn: ui.BoxDecoration;
      tBaseBackgroundColorColumnDecorationOn: ui.BoxDecoration;
      tBaseBackgroundColorColumnPaddingOn: ui.EdgeInsets;
      tTextViewParagraphTextFontSizeOn: number;
      tTextViewParagraphTextFontWeightOn: ui.FontWeight;
      tTextViewParagraphTextColorOn: ui.Color;
      tTextViewColoredTextColorOn: ui.Color;
      tTextViewColoredTextFontSizeOn: number;
      tTextViewColoredTextTextDecorationOnHover: ui.TextDecoration;
      tTextViewParagraphCenterFontSizeOn: number;
      tTextViewParagraphCenterTextAlignOn: ui.TextAlign;
      tTextViewParagraphCenterColorOn: ui.Color;
      tTextViewParagraphCenterPaddingOn: ui.EdgeInsets;
      tTextViewTextOverFlowFontSizeOn: number;
      tTextViewTextOverFlowMaxLinesOn: number;
      tTextViewTextOverFlowTextAlignOn: ui.TextAlign;
      tTextViewTextOverFlowOverflowOn: ui.TextOverflow;
      tInputFieldNormalInputfieldHeightOn: number;
      tInputFieldNormalInputfieldWidthOn: number;
      tInputFieldNormalInputfieldBackgroundColorOn: ui.Color;
      tInputFieldNormalInputfieldCornerRadiusOn: number;
      tInputFieldNormalInputfieldCursorColorOn: ui.Color;
      tInputFieldNormalInputfieldInActiveColorOn: ui.Color;
      tInputFieldNormalInputfieldPlaceHolderColorOn: ui.Color;
      tInputFieldNormalInputfieldStyleOn: ui.TextStyle;
      tInputFieldSmallNormalInputfieldHeightOn: number;
      tInputFieldSmallNormalInputfieldWidthOn: number;
      tInputFieldSmallNormalInputfieldBackgroundColorOn: ui.Color;
      tInputFieldSmallNormalInputfieldCornerRadiusOn: number;
      tInputFieldSmallNormalInputfieldCursorColorOn: ui.Color;
      tInputFieldSmallNormalInputfieldInActiveColorOn: ui.Color;
      tInputFieldSmallNormalInputfieldPlaceHolderColorOn: ui.Color;
      tInputFieldSmallNormalInputfieldStyleOn: ui.TextStyle;
      tInputFieldTestDataInputfieldHeightOn: number;
      tInputFieldTestDataInputfieldWidthOn: number;
      tInputFieldTestDataInputfieldBackgroundColorOn: ui.Color;
      tInputFieldTestDataInputfieldCornerRadiusOn: number;
      tInputFieldTestDataInputfieldCursorColorOn: ui.Color;
      tInputFieldTestDataInputfieldStyleOn: ui.TextStyle;
      tInputFieldDisabledInputfieldWidthOn: number;
      tInputFieldDisabledInputfieldHeightOn: number;
      tInputFieldDisabledInputfieldBackgroundColorOn: ui.Color;
      tInputFieldDisabledInputfieldStyleOn: ui.TextStyle;
      tInputFieldDisabledInputfieldDisableOn: boolean;
      tInputFieldDisabledInputfieldDecorationOn: ui.BoxDecoration;
      tInputFieldSmallDisabledInputfieldWidthOn: number;
      tInputFieldSmallDisabledInputfieldHeightOn: number;
      tInputFieldSmallDisabledInputfieldBackgroundColorOn: ui.Color;
      tInputFieldSmallDisabledInputfieldStyleOn: ui.TextStyle;
      tInputFieldSmallDisabledInputfieldDisableOn: boolean;
      tInputFieldSmallDisabledInputfieldDecorationOn: ui.BoxDecoration;
      tInputFieldSearchInputfieldInActiveColorOn: ui.Color;
      tInputFieldSearchInputfieldPlaceHolderColorOn: ui.Color;
      tInputFieldSearchInputfieldActiveColorOn: ui.Color;
      tInputFieldSearchInputfieldPaddingOn: ui.EdgeInsets;
      tInputFieldDescriptionInputfieldHeightOn: number;
      tInputFieldDescriptionInputfieldWidthOn: number;
      tInputFieldDescriptionInputfieldCornerRadiusOn: number;
      tInputFieldDescriptionInputfieldBackgroundColorOn: ui.Color;
      tInputFieldDescriptionInputfieldPlaceHolderColorOn: ui.Color;
      tInputFieldDescriptionInputfieldStyleOn: ui.TextStyle;
      tBasePanelColorWithBorderDecorationOn: ui.BoxDecoration;
      tTextViewDropDownBuilderTextColorOn: ui.Color;
      tTextViewDropDownBuilderTextPaddingOn: ui.EdgeInsets;
      tDropDownRoundRadiusDropDownHeightOn: number;
      tDropDownRoundRadiusDropDownOnHoverColorOn: ui.Color;
      tDropDownRoundRadiusDropDownPlaceHolderColorOn: ui.Color;
      tDropDownRoundRadiusDropDownDropDownDecorationOn: ui.BoxDecoration;
      tDropDownRoundRadiusDropDownViewDecorationOn: ui.BoxDecoration;
      tBasePrimaryListTileDecorationOn: ui.BoxDecoration;
      tBasePrimaryListTileTextStyleOn: ui.TextStyle;
      tBasePrimaryListTileDecorationOnHover: ui.BoxDecoration;
      tBasePrimaryListTileTextStyleOnHover: ui.TextStyle;
      tBasePrimaryListTileDecorationOnFocus: ui.BoxDecoration;
      tBasePrimaryListTileDecorationOnSelected: ui.BoxDecoration;
      tBasePrimaryListTileTextStyleOnSelected: ui.TextStyle;
      tBasePrimaryListTileDecorationOnHoverSelected: ui.BoxDecoration;
      tBasePrimaryListTileTextStyleOnHoverSelected: ui.TextStyle;
      tBaseExpEditorStyleDecorationOn: ui.BoxDecoration;
      tBaseDarkBackgroundDecorationOn: ui.BoxDecoration;
      tBaseDarkBackgroundTextStyleOn: ui.TextStyle;
      tContainerLinearGradiantWidthOn: number;
      tContainerLinearGradiantHeightOn: number;
      tContainerLinearGradiantDecorationOn: ui.BoxDecoration;
      tBaseSweepGradiantWidthOn: number;
      tBaseSweepGradiantHeightOn: number;
      tBaseSweepGradiantDecorationOn: ui.BoxDecoration;
      tContainerRadiualGradiantWidthOn: number;
      tContainerRadiualGradiantHeightOn: number;
      tContainerRadiualGradiantDecorationOn: ui.BoxDecoration;
      tButtonUnderlineButtonTextStyleOn: ui.TextStyle;
      tButtonUnderlineButtonTextStyleOnHover: ui.TextStyle;
      tButtonUnderlineButtonTextStyleOnFocusHover: ui.TextStyle;
      tButtonUnderlineButtonDecorationOnFocus: ui.BoxDecoration;
      tButtonUnderlineButtonTextStyleOnFocus: ui.TextStyle;
      tButtonBoldUnderlineButtonTextStyleOn: ui.TextStyle;
      tButtonBoldUnderlineButtonTextStyleOnHover: ui.TextStyle;
      tButtonBoldUnderlineButtonTextStyleOnFocus: ui.TextStyle;
      tButtonBoldUnderlineButtonTextStyleOnFocusHover: ui.TextStyle;
      tSearchComponentSearchFieldDecorationOn: ui.BoxDecoration;
      tSearchComponentSearchFieldDecorationOnFocus: ui.BoxDecoration;
      tCheckboxWithTextActiveCheckboxWithTextActiveColorOn: ui.Color;
      tDoubleInputFieldTestDoubleInputFieldHeightOn: number;
      tDoubleInputFieldTestDoubleInputFieldWidthOn: number;
      tDoubleInputFieldTestDoubleInputFieldBackgroundColorOn: ui.Color;
      tDoubleInputFieldTestDoubleInputFieldCornerRadiusOn: number;
      tIntegerInputFieldTestIntegerInputFieldHeightOn: number;
      tIntegerInputFieldTestIntegerInputFieldWidthOn: number;
      tIntegerInputFieldTestIntegerInputFieldBackgroundColorOn: ui.Color;
      tIntegerInputFieldTestIntegerInputFieldCornerRadiusOn: number;
      tAutoSearchTextWithBuilderAutoRoundRadiusDropDownHeightOn: number;
      tAutoSearchTextWithBuilderAutoRoundRadiusDropDownViewDecorationOn: ui.BoxDecoration;
      tAutoSearchTextWithBuilderAutoRoundRadiusDropDownDecorationOn: ui.BoxDecoration;
      tInputFieldInputBasicBackgroundColorOn: ui.Color;
      tInputFieldInputBasicCornerRadiusOn: number;
      tInputFieldInputBasicDecorationOn: ui.BoxDecoration;
      tInputFieldFixedInputFieldBackgroundColorOn: ui.Color;
      tInputFieldFixedInputFieldCornerRadiusOn: number;
      tInputFieldFixedInputFieldDecorationOn: ui.BoxDecoration;
      tBaseCardDecorationOn: ui.BoxDecoration;
      tBaseDefaultPopUpDecorationOn: ui.BoxDecoration;
      tTextViewCollapsableHeaderTextColorOn: ui.Color;
      tTextViewCollapsableHeaderTextFontSizeOn: number;
      tTextViewCollapsableHeaderTextFontWeightOn: ui.FontWeight;
      tBaseToolTipDecorationDecorationOn: ui.BoxDecoration;
      tBaseToolTipDecorationPaddingOn: ui.EdgeInsets;
      tBaseToolTipDecorationTextStyleOn: ui.TextStyle;
      tTableRowTableRowHeadingDecorationOn: ui.BoxDecoration;
      tBaseBackgroundColorColumn2DecorationOn: ui.BoxDecoration;
      tBaseBackgroundColorColumn2PaddingOn: ui.EdgeInsets;
      tEditTextFieldNormalEditTextFieldHeightOn: number;
      tEditTextFieldNormalEditTextFieldWidthOn: number;
      tEditTextFieldNormalEditTextFieldDecorationOn: ui.BoxDecoration;
      tCheckboxWitheLabelActiveCheckboxWithLabelActiveColorOn: ui.Color;
      tContainerDropAreaHeightOn: number;
      tContainerDropAreaHeightOnHover: number;
      tContainerDropAreaDecorationOnHover: ui.BoxDecoration;
      tBaseSelectedTabContainerHeightOn: number;
      tBaseSelectedTabContainerWidthOn: number;
      tBaseSelectedTabContainerDecorationOn: ui.BoxDecoration;
      tTextViewTabsFontSizeOn: number;
      tTextViewTabsFontWeightOn: ui.FontWeight;
      tRowChatBoxDecorationOn: ui.BoxDecoration;
      tRowChatBoxPaddingOn: ui.EdgeInsets;
      tColumnTemplateCardPaddingOn: ui.EdgeInsets;
      tColumnTemplateCardDecorationOn: ui.BoxDecoration;
      tButtonBtnLinkDecorationOn: ui.BoxDecoration;
      tButtonBtnLinkTextStyleOn: ui.TextStyle;
      tButtonBtnLinkTextStyleOnHover: ui.TextStyle;
      tTextViewHeadlineThreeFontSizeOn: number;
      tTextViewHeadlineThreeFontWeightOn: ui.FontWeight;
      tTextViewLabelColorOn: ui.Color;
      tTextViewLabelTextAlignOn: ui.TextAlign;
      tTextViewLabelMarginOn: ui.EdgeInsets;
      tButtonOutlineButtonDecorationOn: ui.BoxDecoration;
      tButtonOutlineButtonTextStyleOn: ui.TextStyle;
      tButtonOutlineButtonPaddingOn: ui.EdgeInsets;
      tTextViewErrorLabelColorOn: ui.Color;
      tTextViewErrorLabelFontFamilyOn: string;
      tTextViewErrorLabelFontSizeOn: number;
      tTextViewErrorLabelMarginOn: ui.EdgeInsets;
      tButtonNewResponceOptionButtonDecorationOn: ui.BoxDecoration;
      tButtonNewResponceOptionButtonTextStyleOn: ui.TextStyle;
      tButtonNewResponceOptionButtonTextStyleOnHover: ui.TextStyle;
      tButtonPrimaryNewDecorationOn: ui.BoxDecoration;
      tButtonPrimaryNewPaddingOn: ui.EdgeInsets;
      tButtonPrimaryNewTextStyleOn: ui.TextStyle;
      tButtonPrimaryNewDecorationOnHover: ui.BoxDecoration;
      tButtonPrimaryNewPaddingOnHover: ui.EdgeInsets;
      tButtonPrimaryNewTextStyleOnHover: ui.TextStyle;
      tButtonResponceOptionButtonPaddingOn: ui.EdgeInsets;
      tButtonResponceOptionButtonDecorationOn: ui.BoxDecoration;
      tButtonResponceOptionButtonTextStyleOn: ui.TextStyle;
      tButtonResponceOptionButtonDecorationOnHover: ui.BoxDecoration;
      tButtonResponceOptionButtonPaddingOnHover: ui.EdgeInsets;
      tButtonResponceOptionButtonTextStyleOnHover: ui.TextStyle;
      tButtonSecondaryDecorationOn: ui.BoxDecoration;
      tButtonSecondaryPaddingOn: ui.EdgeInsets;
      tButtonSecondaryConstraintsOn: ui.BoxConstraints;
      tButtonSecondaryTextStyleOn: ui.TextStyle;
      tButtonSecondaryDecorationOnHover: ui.BoxDecoration;
      tButtonSecondaryPaddingOnHover: ui.EdgeInsets;
      tButtonSecondaryConstraintsOnHover: ui.BoxConstraints;
      tButtonSecondaryTextStyleOnHover: ui.TextStyle;
      tButtonSecondaryNewPaddingOn: ui.EdgeInsets;
      tButtonSecondaryNewDecorationOn: ui.BoxDecoration;
      tButtonSecondaryNewTextStyleOn: ui.TextStyle;
      tButtonSecondaryNewDecorationOnHover: ui.BoxDecoration;
      tButtonSecondaryNewPaddingOnHover: ui.EdgeInsets;
      tButtonSecondaryNewTextStyleOnHover: ui.TextStyle;
      tTextViewTableCellTextFontSizeOn: number;
      tTextViewTableCellTextColorOn: ui.Color;
      tTextViewTableCellTextFontFamilyOn: string;
      tTextViewTableHeaderFontSizeOn: number;
      tTextViewTableHeaderColorOn: ui.Color;
      tTextViewTableHeaderFontFamilyOn: string;
      tTableRowTableRowOnebgDecorationOn: ui.BoxDecoration;
      tTableRowTableRowOnebgPaddingOn: ui.EdgeInsets;
      tTableRowTableRowTwobgDecorationOn: ui.BoxDecoration;
      tTableRowTableRowTwobgPaddingOn: ui.EdgeInsets;
      c1: ui.Color;
      c2: ui.Color;
      c3: ui.Color;
      c4: ui.Color;
      c5: ui.Color;
      c6: ui.Color;
      c7: ui.Color;
      c8: ui.Color;
      c9: ui.Color;
      c10: ui.Color;
      c11: ui.Color;
      c12: ui.Color;
      c13: ui.Color;
      c14: ui.Color;
      c15: ui.Color;
      c16: ui.Color;
      c17: ui.Color;
    }>
  ) {
    this.themeName = d3eParams?.themeName;

    this.color = d3eParams?.color;

    this.textStyle = d3eParams?.textStyle;

    this.tooltipBackgroundColor = d3eParams?.tooltipBackgroundColor;

    this.tooltipTextColor = d3eParams?.tooltipTextColor;

    this.tTableRowTableBackgroundDecorationOn =
      d3eParams?.tTableRowTableBackgroundDecorationOn;

    this.tTableRowTableBackgroundPaddingOn =
      d3eParams?.tTableRowTableBackgroundPaddingOn;

    this.tTableRowTableBackgroundTextStyleOn =
      d3eParams?.tTableRowTableBackgroundTextStyleOn;

    this.tTableRowTableBackgroundConstraintsOn =
      d3eParams?.tTableRowTableBackgroundConstraintsOn;

    this.tTableCellDefaultCellVerticalAlignmentOn =
      d3eParams?.tTableCellDefaultCellVerticalAlignmentOn;

    this.tTableDefaultTableBorderOn = d3eParams?.tTableDefaultTableBorderOn;

    this.tButtonButtonWithNoBorderRadiusDecorationOn =
      d3eParams?.tButtonButtonWithNoBorderRadiusDecorationOn;

    this.tButtonButtonWithNoBorderRadiusHeightOn =
      d3eParams?.tButtonButtonWithNoBorderRadiusHeightOn;

    this.tButtonButtonWithNoBorderRadiusConstraintsOn =
      d3eParams?.tButtonButtonWithNoBorderRadiusConstraintsOn;

    this.tButtonButtonWithNoBorderRadiusTextStyleOn =
      d3eParams?.tButtonButtonWithNoBorderRadiusTextStyleOn;

    this.tButtonButtonWithNoBorderRadiusDecorationOnHover =
      d3eParams?.tButtonButtonWithNoBorderRadiusDecorationOnHover;

    this.tButtonButtonWithNoBorderRadiusTextStyleOnHover =
      d3eParams?.tButtonButtonWithNoBorderRadiusTextStyleOnHover;

    this.tButtonButtonWithNoBorderRadiusDecorationOnFocus =
      d3eParams?.tButtonButtonWithNoBorderRadiusDecorationOnFocus;

    this.tButtonButtonWithNoBorderRadiusTextStyleOnFocus =
      d3eParams?.tButtonButtonWithNoBorderRadiusTextStyleOnFocus;

    this.tButtonPrimaryButtonDecorationOn =
      d3eParams?.tButtonPrimaryButtonDecorationOn;

    this.tButtonPrimaryButtonPaddingOn =
      d3eParams?.tButtonPrimaryButtonPaddingOn;

    this.tButtonPrimaryButtonConstraintsOn =
      d3eParams?.tButtonPrimaryButtonConstraintsOn;

    this.tButtonPrimaryButtonTextStyleOn =
      d3eParams?.tButtonPrimaryButtonTextStyleOn;

    this.tButtonPrimaryButtonDecorationOnHover =
      d3eParams?.tButtonPrimaryButtonDecorationOnHover;

    this.tButtonPrimaryButtonTextStyleOnHover =
      d3eParams?.tButtonPrimaryButtonTextStyleOnHover;

    this.tButtonPrimaryButtonDecorationOnFocus =
      d3eParams?.tButtonPrimaryButtonDecorationOnFocus;

    this.tButtonPrimaryButtonTextStyleOnFocus =
      d3eParams?.tButtonPrimaryButtonTextStyleOnFocus;

    this.tButtonDisabledPrimaryButtonDecorationOn =
      d3eParams?.tButtonDisabledPrimaryButtonDecorationOn;

    this.tButtonDisabledPrimaryButtonPaddingOn =
      d3eParams?.tButtonDisabledPrimaryButtonPaddingOn;

    this.tButtonDisabledPrimaryButtonConstraintsOn =
      d3eParams?.tButtonDisabledPrimaryButtonConstraintsOn;

    this.tButtonDisabledPrimaryButtonTextStyleOn =
      d3eParams?.tButtonDisabledPrimaryButtonTextStyleOn;

    this.tButtonSecondaryButtonPaddingOn =
      d3eParams?.tButtonSecondaryButtonPaddingOn;

    this.tButtonSecondaryButtonConstraintsOn =
      d3eParams?.tButtonSecondaryButtonConstraintsOn;

    this.tButtonSecondaryButtonDecorationOn =
      d3eParams?.tButtonSecondaryButtonDecorationOn;

    this.tButtonSecondaryButtonTextStyleOn =
      d3eParams?.tButtonSecondaryButtonTextStyleOn;

    this.tButtonSecondaryButtonDecorationOnHover =
      d3eParams?.tButtonSecondaryButtonDecorationOnHover;

    this.tButtonSecondaryButtonTextStyleOnHover =
      d3eParams?.tButtonSecondaryButtonTextStyleOnHover;

    this.tButtonSecondaryButtonDecorationOnFocus =
      d3eParams?.tButtonSecondaryButtonDecorationOnFocus;

    this.tButtonSecondaryButtonTextStyleOnFocus =
      d3eParams?.tButtonSecondaryButtonTextStyleOnFocus;

    this.tButtonAddButtonDecorationOn = d3eParams?.tButtonAddButtonDecorationOn;

    this.tButtonAddButtonTextStyleOn = d3eParams?.tButtonAddButtonTextStyleOn;

    this.tButtonAddButtonHeightOn = d3eParams?.tButtonAddButtonHeightOn;

    this.tButtonAddButtonPaddingOn = d3eParams?.tButtonAddButtonPaddingOn;

    this.tButtonAddButtonConstraintsOn =
      d3eParams?.tButtonAddButtonConstraintsOn;

    this.tButtonAddButtonDecorationOnHover =
      d3eParams?.tButtonAddButtonDecorationOnHover;

    this.tButtonAddButtonTextStyleOnHover =
      d3eParams?.tButtonAddButtonTextStyleOnHover;

    this.tButtonAddButtonDecorationOnFocus =
      d3eParams?.tButtonAddButtonDecorationOnFocus;

    this.tButtonAddButtonTextStyleOnFocus =
      d3eParams?.tButtonAddButtonTextStyleOnFocus;

    this.tButtonDeleteButtonDecorationOnHover =
      d3eParams?.tButtonDeleteButtonDecorationOnHover;

    this.tButtonDeleteButtonTextStyleOnHover =
      d3eParams?.tButtonDeleteButtonTextStyleOnHover;

    this.tButtonDeleteButtonDecorationOn =
      d3eParams?.tButtonDeleteButtonDecorationOn;

    this.tButtonDeleteButtonPaddingOn = d3eParams?.tButtonDeleteButtonPaddingOn;

    this.tButtonDeleteButtonConstraintsOn =
      d3eParams?.tButtonDeleteButtonConstraintsOn;

    this.tButtonDeleteButtonTextStyleOn =
      d3eParams?.tButtonDeleteButtonTextStyleOn;

    this.tButtonDeleteButtonDecorationOnFocus =
      d3eParams?.tButtonDeleteButtonDecorationOnFocus;

    this.tButtonDeleteButtonTextStyleOnFocus =
      d3eParams?.tButtonDeleteButtonTextStyleOnFocus;

    this.tTextViewListTileTextFontSizeOn =
      d3eParams?.tTextViewListTileTextFontSizeOn;

    this.tTextViewListTileTextFontWeightOn =
      d3eParams?.tTextViewListTileTextFontWeightOn;

    this.tTextViewListTileTextColorOn = d3eParams?.tTextViewListTileTextColorOn;

    this.tTextViewListTileTextOverflowOn =
      d3eParams?.tTextViewListTileTextOverflowOn;

    this.tTextViewListTileTextOnLightBackgroundFontSizeOn =
      d3eParams?.tTextViewListTileTextOnLightBackgroundFontSizeOn;

    this.tTextViewListTileTextOnLightBackgroundFontWeightOn =
      d3eParams?.tTextViewListTileTextOnLightBackgroundFontWeightOn;

    this.tTextViewListTileTextOnLightBackgroundColorOn =
      d3eParams?.tTextViewListTileTextOnLightBackgroundColorOn;

    this.tTextViewBoldHeadingFontSizeOn =
      d3eParams?.tTextViewBoldHeadingFontSizeOn;

    this.tTextViewBoldHeadingFontWeightOn =
      d3eParams?.tTextViewBoldHeadingFontWeightOn;

    this.tTextViewBoldHeadingColorOn = d3eParams?.tTextViewBoldHeadingColorOn;

    this.tTextViewBoldHeadingPaddingOn =
      d3eParams?.tTextViewBoldHeadingPaddingOn;

    this.tTextViewHeadingFontSizeOn = d3eParams?.tTextViewHeadingFontSizeOn;

    this.tTextViewHeadingFontWeightOn = d3eParams?.tTextViewHeadingFontWeightOn;

    this.tTextViewHeadingTextAlignOn = d3eParams?.tTextViewHeadingTextAlignOn;

    this.tTextViewHeadingColorOn = d3eParams?.tTextViewHeadingColorOn;

    this.tTextViewParagraphHeadingFontSizeOn =
      d3eParams?.tTextViewParagraphHeadingFontSizeOn;

    this.tTextViewParagraphHeadingFontWeightOn =
      d3eParams?.tTextViewParagraphHeadingFontWeightOn;

    this.tTextViewParagraphHeadingTextAlignOn =
      d3eParams?.tTextViewParagraphHeadingTextAlignOn;

    this.tTextViewParagraphHeadingColorOn =
      d3eParams?.tTextViewParagraphHeadingColorOn;

    this.tTextViewParagraphHeadingPaddingOn =
      d3eParams?.tTextViewParagraphHeadingPaddingOn;

    this.tCheckboxActiveCheckboxActiveColorOn =
      d3eParams?.tCheckboxActiveCheckboxActiveColorOn;

    this.tIconButtonIconButtonDefaultColorOn =
      d3eParams?.tIconButtonIconButtonDefaultColorOn;

    this.tIconButtonIconButtonDefaultHoverColorOn =
      d3eParams?.tIconButtonIconButtonDefaultHoverColorOn;

    this.tIconViewIconViewDefaultColorOn =
      d3eParams?.tIconViewIconViewDefaultColorOn;

    this.tIconViewIconViewDefaultColorOnHover =
      d3eParams?.tIconViewIconViewDefaultColorOnHover;

    this.tIconViewIconViewDefaultColorOnFocus =
      d3eParams?.tIconViewIconViewDefaultColorOnFocus;

    this.tTextViewTitleFontSizeOn = d3eParams?.tTextViewTitleFontSizeOn;

    this.tTextViewTitleColorOn = d3eParams?.tTextViewTitleColorOn;

    this.tTextViewTitleFontWeightOn = d3eParams?.tTextViewTitleFontWeightOn;

    this.tTextViewTitleTextAlignOn = d3eParams?.tTextViewTitleTextAlignOn;

    this.tRowSuccessBackgroundDecorationOn =
      d3eParams?.tRowSuccessBackgroundDecorationOn;

    this.tRowSuccessBackgroundPaddingOn =
      d3eParams?.tRowSuccessBackgroundPaddingOn;

    this.tTextViewSuccessErrorTextFontSizeOn =
      d3eParams?.tTextViewSuccessErrorTextFontSizeOn;

    this.tTextViewSuccessErrorTextTextAlignOn =
      d3eParams?.tTextViewSuccessErrorTextTextAlignOn;

    this.tTextViewSuccessErrorTextColorOn =
      d3eParams?.tTextViewSuccessErrorTextColorOn;

    this.tTextViewErrorMessageColorOn = d3eParams?.tTextViewErrorMessageColorOn;

    this.tTextViewErrorMessageFontSizeOn =
      d3eParams?.tTextViewErrorMessageFontSizeOn;

    this.tTextViewErrorMessageTextAlignOn =
      d3eParams?.tTextViewErrorMessageTextAlignOn;

    this.tTextViewListTextFontSizeOn = d3eParams?.tTextViewListTextFontSizeOn;

    this.tTextViewListTextColorOn = d3eParams?.tTextViewListTextColorOn;

    this.tTextViewListTextTextAlignOn = d3eParams?.tTextViewListTextTextAlignOn;

    this.tTextViewListTextOverflowOn = d3eParams?.tTextViewListTextOverflowOn;

    this.tTextViewLabelTextColorOn = d3eParams?.tTextViewLabelTextColorOn;

    this.tTextViewLabelTextTextAlignOn =
      d3eParams?.tTextViewLabelTextTextAlignOn;

    this.tTextViewLabelTextFontSizeOn = d3eParams?.tTextViewLabelTextFontSizeOn;

    this.tTextViewLabelTextFontWeightOn =
      d3eParams?.tTextViewLabelTextFontWeightOn;

    this.tBaseBackgroundColorDecorationOn =
      d3eParams?.tBaseBackgroundColorDecorationOn;

    this.tBaseBackgroundColorColumnDecorationOn =
      d3eParams?.tBaseBackgroundColorColumnDecorationOn;

    this.tBaseBackgroundColorColumnPaddingOn =
      d3eParams?.tBaseBackgroundColorColumnPaddingOn;

    this.tTextViewParagraphTextFontSizeOn =
      d3eParams?.tTextViewParagraphTextFontSizeOn;

    this.tTextViewParagraphTextFontWeightOn =
      d3eParams?.tTextViewParagraphTextFontWeightOn;

    this.tTextViewParagraphTextColorOn =
      d3eParams?.tTextViewParagraphTextColorOn;

    this.tTextViewColoredTextColorOn = d3eParams?.tTextViewColoredTextColorOn;

    this.tTextViewColoredTextFontSizeOn =
      d3eParams?.tTextViewColoredTextFontSizeOn;

    this.tTextViewColoredTextTextDecorationOnHover =
      d3eParams?.tTextViewColoredTextTextDecorationOnHover;

    this.tTextViewParagraphCenterFontSizeOn =
      d3eParams?.tTextViewParagraphCenterFontSizeOn;

    this.tTextViewParagraphCenterTextAlignOn =
      d3eParams?.tTextViewParagraphCenterTextAlignOn;

    this.tTextViewParagraphCenterColorOn =
      d3eParams?.tTextViewParagraphCenterColorOn;

    this.tTextViewParagraphCenterPaddingOn =
      d3eParams?.tTextViewParagraphCenterPaddingOn;

    this.tTextViewTextOverFlowFontSizeOn =
      d3eParams?.tTextViewTextOverFlowFontSizeOn;

    this.tTextViewTextOverFlowMaxLinesOn =
      d3eParams?.tTextViewTextOverFlowMaxLinesOn;

    this.tTextViewTextOverFlowTextAlignOn =
      d3eParams?.tTextViewTextOverFlowTextAlignOn;

    this.tTextViewTextOverFlowOverflowOn =
      d3eParams?.tTextViewTextOverFlowOverflowOn;

    this.tInputFieldNormalInputfieldHeightOn =
      d3eParams?.tInputFieldNormalInputfieldHeightOn;

    this.tInputFieldNormalInputfieldWidthOn =
      d3eParams?.tInputFieldNormalInputfieldWidthOn;

    this.tInputFieldNormalInputfieldBackgroundColorOn =
      d3eParams?.tInputFieldNormalInputfieldBackgroundColorOn;

    this.tInputFieldNormalInputfieldCornerRadiusOn =
      d3eParams?.tInputFieldNormalInputfieldCornerRadiusOn;

    this.tInputFieldNormalInputfieldCursorColorOn =
      d3eParams?.tInputFieldNormalInputfieldCursorColorOn;

    this.tInputFieldNormalInputfieldInActiveColorOn =
      d3eParams?.tInputFieldNormalInputfieldInActiveColorOn;

    this.tInputFieldNormalInputfieldPlaceHolderColorOn =
      d3eParams?.tInputFieldNormalInputfieldPlaceHolderColorOn;

    this.tInputFieldNormalInputfieldStyleOn =
      d3eParams?.tInputFieldNormalInputfieldStyleOn;

    this.tInputFieldSmallNormalInputfieldHeightOn =
      d3eParams?.tInputFieldSmallNormalInputfieldHeightOn;

    this.tInputFieldSmallNormalInputfieldWidthOn =
      d3eParams?.tInputFieldSmallNormalInputfieldWidthOn;

    this.tInputFieldSmallNormalInputfieldBackgroundColorOn =
      d3eParams?.tInputFieldSmallNormalInputfieldBackgroundColorOn;

    this.tInputFieldSmallNormalInputfieldCornerRadiusOn =
      d3eParams?.tInputFieldSmallNormalInputfieldCornerRadiusOn;

    this.tInputFieldSmallNormalInputfieldCursorColorOn =
      d3eParams?.tInputFieldSmallNormalInputfieldCursorColorOn;

    this.tInputFieldSmallNormalInputfieldInActiveColorOn =
      d3eParams?.tInputFieldSmallNormalInputfieldInActiveColorOn;

    this.tInputFieldSmallNormalInputfieldPlaceHolderColorOn =
      d3eParams?.tInputFieldSmallNormalInputfieldPlaceHolderColorOn;

    this.tInputFieldSmallNormalInputfieldStyleOn =
      d3eParams?.tInputFieldSmallNormalInputfieldStyleOn;

    this.tInputFieldTestDataInputfieldHeightOn =
      d3eParams?.tInputFieldTestDataInputfieldHeightOn;

    this.tInputFieldTestDataInputfieldWidthOn =
      d3eParams?.tInputFieldTestDataInputfieldWidthOn;

    this.tInputFieldTestDataInputfieldBackgroundColorOn =
      d3eParams?.tInputFieldTestDataInputfieldBackgroundColorOn;

    this.tInputFieldTestDataInputfieldCornerRadiusOn =
      d3eParams?.tInputFieldTestDataInputfieldCornerRadiusOn;

    this.tInputFieldTestDataInputfieldCursorColorOn =
      d3eParams?.tInputFieldTestDataInputfieldCursorColorOn;

    this.tInputFieldTestDataInputfieldStyleOn =
      d3eParams?.tInputFieldTestDataInputfieldStyleOn;

    this.tInputFieldDisabledInputfieldWidthOn =
      d3eParams?.tInputFieldDisabledInputfieldWidthOn;

    this.tInputFieldDisabledInputfieldHeightOn =
      d3eParams?.tInputFieldDisabledInputfieldHeightOn;

    this.tInputFieldDisabledInputfieldBackgroundColorOn =
      d3eParams?.tInputFieldDisabledInputfieldBackgroundColorOn;

    this.tInputFieldDisabledInputfieldStyleOn =
      d3eParams?.tInputFieldDisabledInputfieldStyleOn;

    this.tInputFieldDisabledInputfieldDisableOn =
      d3eParams?.tInputFieldDisabledInputfieldDisableOn;

    this.tInputFieldDisabledInputfieldDecorationOn =
      d3eParams?.tInputFieldDisabledInputfieldDecorationOn;

    this.tInputFieldSmallDisabledInputfieldWidthOn =
      d3eParams?.tInputFieldSmallDisabledInputfieldWidthOn;

    this.tInputFieldSmallDisabledInputfieldHeightOn =
      d3eParams?.tInputFieldSmallDisabledInputfieldHeightOn;

    this.tInputFieldSmallDisabledInputfieldBackgroundColorOn =
      d3eParams?.tInputFieldSmallDisabledInputfieldBackgroundColorOn;

    this.tInputFieldSmallDisabledInputfieldStyleOn =
      d3eParams?.tInputFieldSmallDisabledInputfieldStyleOn;

    this.tInputFieldSmallDisabledInputfieldDisableOn =
      d3eParams?.tInputFieldSmallDisabledInputfieldDisableOn;

    this.tInputFieldSmallDisabledInputfieldDecorationOn =
      d3eParams?.tInputFieldSmallDisabledInputfieldDecorationOn;

    this.tInputFieldSearchInputfieldInActiveColorOn =
      d3eParams?.tInputFieldSearchInputfieldInActiveColorOn;

    this.tInputFieldSearchInputfieldPlaceHolderColorOn =
      d3eParams?.tInputFieldSearchInputfieldPlaceHolderColorOn;

    this.tInputFieldSearchInputfieldActiveColorOn =
      d3eParams?.tInputFieldSearchInputfieldActiveColorOn;

    this.tInputFieldSearchInputfieldPaddingOn =
      d3eParams?.tInputFieldSearchInputfieldPaddingOn;

    this.tInputFieldDescriptionInputfieldHeightOn =
      d3eParams?.tInputFieldDescriptionInputfieldHeightOn;

    this.tInputFieldDescriptionInputfieldWidthOn =
      d3eParams?.tInputFieldDescriptionInputfieldWidthOn;

    this.tInputFieldDescriptionInputfieldCornerRadiusOn =
      d3eParams?.tInputFieldDescriptionInputfieldCornerRadiusOn;

    this.tInputFieldDescriptionInputfieldBackgroundColorOn =
      d3eParams?.tInputFieldDescriptionInputfieldBackgroundColorOn;

    this.tInputFieldDescriptionInputfieldPlaceHolderColorOn =
      d3eParams?.tInputFieldDescriptionInputfieldPlaceHolderColorOn;

    this.tInputFieldDescriptionInputfieldStyleOn =
      d3eParams?.tInputFieldDescriptionInputfieldStyleOn;

    this.tBasePanelColorWithBorderDecorationOn =
      d3eParams?.tBasePanelColorWithBorderDecorationOn;

    this.tTextViewDropDownBuilderTextColorOn =
      d3eParams?.tTextViewDropDownBuilderTextColorOn;

    this.tTextViewDropDownBuilderTextPaddingOn =
      d3eParams?.tTextViewDropDownBuilderTextPaddingOn;

    this.tDropDownRoundRadiusDropDownHeightOn =
      d3eParams?.tDropDownRoundRadiusDropDownHeightOn;

    this.tDropDownRoundRadiusDropDownOnHoverColorOn =
      d3eParams?.tDropDownRoundRadiusDropDownOnHoverColorOn;

    this.tDropDownRoundRadiusDropDownPlaceHolderColorOn =
      d3eParams?.tDropDownRoundRadiusDropDownPlaceHolderColorOn;

    this.tDropDownRoundRadiusDropDownDropDownDecorationOn =
      d3eParams?.tDropDownRoundRadiusDropDownDropDownDecorationOn;

    this.tDropDownRoundRadiusDropDownViewDecorationOn =
      d3eParams?.tDropDownRoundRadiusDropDownViewDecorationOn;

    this.tBasePrimaryListTileDecorationOn =
      d3eParams?.tBasePrimaryListTileDecorationOn;

    this.tBasePrimaryListTileTextStyleOn =
      d3eParams?.tBasePrimaryListTileTextStyleOn;

    this.tBasePrimaryListTileDecorationOnHover =
      d3eParams?.tBasePrimaryListTileDecorationOnHover;

    this.tBasePrimaryListTileTextStyleOnHover =
      d3eParams?.tBasePrimaryListTileTextStyleOnHover;

    this.tBasePrimaryListTileDecorationOnFocus =
      d3eParams?.tBasePrimaryListTileDecorationOnFocus;

    this.tBasePrimaryListTileDecorationOnSelected =
      d3eParams?.tBasePrimaryListTileDecorationOnSelected;

    this.tBasePrimaryListTileTextStyleOnSelected =
      d3eParams?.tBasePrimaryListTileTextStyleOnSelected;

    this.tBasePrimaryListTileDecorationOnHoverSelected =
      d3eParams?.tBasePrimaryListTileDecorationOnHoverSelected;

    this.tBasePrimaryListTileTextStyleOnHoverSelected =
      d3eParams?.tBasePrimaryListTileTextStyleOnHoverSelected;

    this.tBaseExpEditorStyleDecorationOn =
      d3eParams?.tBaseExpEditorStyleDecorationOn;

    this.tBaseDarkBackgroundDecorationOn =
      d3eParams?.tBaseDarkBackgroundDecorationOn;

    this.tBaseDarkBackgroundTextStyleOn =
      d3eParams?.tBaseDarkBackgroundTextStyleOn;

    this.tContainerLinearGradiantWidthOn =
      d3eParams?.tContainerLinearGradiantWidthOn;

    this.tContainerLinearGradiantHeightOn =
      d3eParams?.tContainerLinearGradiantHeightOn;

    this.tContainerLinearGradiantDecorationOn =
      d3eParams?.tContainerLinearGradiantDecorationOn;

    this.tBaseSweepGradiantWidthOn = d3eParams?.tBaseSweepGradiantWidthOn;

    this.tBaseSweepGradiantHeightOn = d3eParams?.tBaseSweepGradiantHeightOn;

    this.tBaseSweepGradiantDecorationOn =
      d3eParams?.tBaseSweepGradiantDecorationOn;

    this.tContainerRadiualGradiantWidthOn =
      d3eParams?.tContainerRadiualGradiantWidthOn;

    this.tContainerRadiualGradiantHeightOn =
      d3eParams?.tContainerRadiualGradiantHeightOn;

    this.tContainerRadiualGradiantDecorationOn =
      d3eParams?.tContainerRadiualGradiantDecorationOn;

    this.tButtonUnderlineButtonTextStyleOn =
      d3eParams?.tButtonUnderlineButtonTextStyleOn;

    this.tButtonUnderlineButtonTextStyleOnHover =
      d3eParams?.tButtonUnderlineButtonTextStyleOnHover;

    this.tButtonUnderlineButtonTextStyleOnFocusHover =
      d3eParams?.tButtonUnderlineButtonTextStyleOnFocusHover;

    this.tButtonUnderlineButtonDecorationOnFocus =
      d3eParams?.tButtonUnderlineButtonDecorationOnFocus;

    this.tButtonUnderlineButtonTextStyleOnFocus =
      d3eParams?.tButtonUnderlineButtonTextStyleOnFocus;

    this.tButtonBoldUnderlineButtonTextStyleOn =
      d3eParams?.tButtonBoldUnderlineButtonTextStyleOn;

    this.tButtonBoldUnderlineButtonTextStyleOnHover =
      d3eParams?.tButtonBoldUnderlineButtonTextStyleOnHover;

    this.tButtonBoldUnderlineButtonTextStyleOnFocus =
      d3eParams?.tButtonBoldUnderlineButtonTextStyleOnFocus;

    this.tButtonBoldUnderlineButtonTextStyleOnFocusHover =
      d3eParams?.tButtonBoldUnderlineButtonTextStyleOnFocusHover;

    this.tSearchComponentSearchFieldDecorationOn =
      d3eParams?.tSearchComponentSearchFieldDecorationOn;

    this.tSearchComponentSearchFieldDecorationOnFocus =
      d3eParams?.tSearchComponentSearchFieldDecorationOnFocus;

    this.tCheckboxWithTextActiveCheckboxWithTextActiveColorOn =
      d3eParams?.tCheckboxWithTextActiveCheckboxWithTextActiveColorOn;

    this.tDoubleInputFieldTestDoubleInputFieldHeightOn =
      d3eParams?.tDoubleInputFieldTestDoubleInputFieldHeightOn;

    this.tDoubleInputFieldTestDoubleInputFieldWidthOn =
      d3eParams?.tDoubleInputFieldTestDoubleInputFieldWidthOn;

    this.tDoubleInputFieldTestDoubleInputFieldBackgroundColorOn =
      d3eParams?.tDoubleInputFieldTestDoubleInputFieldBackgroundColorOn;

    this.tDoubleInputFieldTestDoubleInputFieldCornerRadiusOn =
      d3eParams?.tDoubleInputFieldTestDoubleInputFieldCornerRadiusOn;

    this.tIntegerInputFieldTestIntegerInputFieldHeightOn =
      d3eParams?.tIntegerInputFieldTestIntegerInputFieldHeightOn;

    this.tIntegerInputFieldTestIntegerInputFieldWidthOn =
      d3eParams?.tIntegerInputFieldTestIntegerInputFieldWidthOn;

    this.tIntegerInputFieldTestIntegerInputFieldBackgroundColorOn =
      d3eParams?.tIntegerInputFieldTestIntegerInputFieldBackgroundColorOn;

    this.tIntegerInputFieldTestIntegerInputFieldCornerRadiusOn =
      d3eParams?.tIntegerInputFieldTestIntegerInputFieldCornerRadiusOn;

    this.tAutoSearchTextWithBuilderAutoRoundRadiusDropDownHeightOn =
      d3eParams?.tAutoSearchTextWithBuilderAutoRoundRadiusDropDownHeightOn;

    this.tAutoSearchTextWithBuilderAutoRoundRadiusDropDownViewDecorationOn =
      d3eParams?.tAutoSearchTextWithBuilderAutoRoundRadiusDropDownViewDecorationOn;

    this.tAutoSearchTextWithBuilderAutoRoundRadiusDropDownDecorationOn =
      d3eParams?.tAutoSearchTextWithBuilderAutoRoundRadiusDropDownDecorationOn;

    this.tInputFieldInputBasicBackgroundColorOn =
      d3eParams?.tInputFieldInputBasicBackgroundColorOn;

    this.tInputFieldInputBasicCornerRadiusOn =
      d3eParams?.tInputFieldInputBasicCornerRadiusOn;

    this.tInputFieldInputBasicDecorationOn =
      d3eParams?.tInputFieldInputBasicDecorationOn;

    this.tInputFieldFixedInputFieldBackgroundColorOn =
      d3eParams?.tInputFieldFixedInputFieldBackgroundColorOn;

    this.tInputFieldFixedInputFieldCornerRadiusOn =
      d3eParams?.tInputFieldFixedInputFieldCornerRadiusOn;

    this.tInputFieldFixedInputFieldDecorationOn =
      d3eParams?.tInputFieldFixedInputFieldDecorationOn;

    this.tBaseCardDecorationOn = d3eParams?.tBaseCardDecorationOn;

    this.tBaseDefaultPopUpDecorationOn =
      d3eParams?.tBaseDefaultPopUpDecorationOn;

    this.tTextViewCollapsableHeaderTextColorOn =
      d3eParams?.tTextViewCollapsableHeaderTextColorOn;

    this.tTextViewCollapsableHeaderTextFontSizeOn =
      d3eParams?.tTextViewCollapsableHeaderTextFontSizeOn;

    this.tTextViewCollapsableHeaderTextFontWeightOn =
      d3eParams?.tTextViewCollapsableHeaderTextFontWeightOn;

    this.tBaseToolTipDecorationDecorationOn =
      d3eParams?.tBaseToolTipDecorationDecorationOn;

    this.tBaseToolTipDecorationPaddingOn =
      d3eParams?.tBaseToolTipDecorationPaddingOn;

    this.tBaseToolTipDecorationTextStyleOn =
      d3eParams?.tBaseToolTipDecorationTextStyleOn;

    this.tTableRowTableRowHeadingDecorationOn =
      d3eParams?.tTableRowTableRowHeadingDecorationOn;

    this.tBaseBackgroundColorColumn2DecorationOn =
      d3eParams?.tBaseBackgroundColorColumn2DecorationOn;

    this.tBaseBackgroundColorColumn2PaddingOn =
      d3eParams?.tBaseBackgroundColorColumn2PaddingOn;

    this.tEditTextFieldNormalEditTextFieldHeightOn =
      d3eParams?.tEditTextFieldNormalEditTextFieldHeightOn;

    this.tEditTextFieldNormalEditTextFieldWidthOn =
      d3eParams?.tEditTextFieldNormalEditTextFieldWidthOn;

    this.tEditTextFieldNormalEditTextFieldDecorationOn =
      d3eParams?.tEditTextFieldNormalEditTextFieldDecorationOn;

    this.tCheckboxWitheLabelActiveCheckboxWithLabelActiveColorOn =
      d3eParams?.tCheckboxWitheLabelActiveCheckboxWithLabelActiveColorOn;

    this.tContainerDropAreaHeightOn = d3eParams?.tContainerDropAreaHeightOn;

    this.tContainerDropAreaHeightOnHover =
      d3eParams?.tContainerDropAreaHeightOnHover;

    this.tContainerDropAreaDecorationOnHover =
      d3eParams?.tContainerDropAreaDecorationOnHover;

    this.tBaseSelectedTabContainerHeightOn =
      d3eParams?.tBaseSelectedTabContainerHeightOn;

    this.tBaseSelectedTabContainerWidthOn =
      d3eParams?.tBaseSelectedTabContainerWidthOn;

    this.tBaseSelectedTabContainerDecorationOn =
      d3eParams?.tBaseSelectedTabContainerDecorationOn;

    this.tTextViewTabsFontSizeOn = d3eParams?.tTextViewTabsFontSizeOn;

    this.tTextViewTabsFontWeightOn = d3eParams?.tTextViewTabsFontWeightOn;

    this.tRowChatBoxDecorationOn = d3eParams?.tRowChatBoxDecorationOn;

    this.tRowChatBoxPaddingOn = d3eParams?.tRowChatBoxPaddingOn;

    this.tColumnTemplateCardPaddingOn = d3eParams?.tColumnTemplateCardPaddingOn;

    this.tColumnTemplateCardDecorationOn =
      d3eParams?.tColumnTemplateCardDecorationOn;

    this.tButtonBtnLinkDecorationOn = d3eParams?.tButtonBtnLinkDecorationOn;

    this.tButtonBtnLinkTextStyleOn = d3eParams?.tButtonBtnLinkTextStyleOn;

    this.tButtonBtnLinkTextStyleOnHover =
      d3eParams?.tButtonBtnLinkTextStyleOnHover;

    this.tTextViewHeadlineThreeFontSizeOn =
      d3eParams?.tTextViewHeadlineThreeFontSizeOn;

    this.tTextViewHeadlineThreeFontWeightOn =
      d3eParams?.tTextViewHeadlineThreeFontWeightOn;

    this.tTextViewLabelColorOn = d3eParams?.tTextViewLabelColorOn;

    this.tTextViewLabelTextAlignOn = d3eParams?.tTextViewLabelTextAlignOn;

    this.tTextViewLabelMarginOn = d3eParams?.tTextViewLabelMarginOn;

    this.tButtonOutlineButtonDecorationOn =
      d3eParams?.tButtonOutlineButtonDecorationOn;

    this.tButtonOutlineButtonTextStyleOn =
      d3eParams?.tButtonOutlineButtonTextStyleOn;

    this.tButtonOutlineButtonPaddingOn =
      d3eParams?.tButtonOutlineButtonPaddingOn;

    this.tTextViewErrorLabelColorOn = d3eParams?.tTextViewErrorLabelColorOn;

    this.tTextViewErrorLabelFontFamilyOn =
      d3eParams?.tTextViewErrorLabelFontFamilyOn;

    this.tTextViewErrorLabelFontSizeOn =
      d3eParams?.tTextViewErrorLabelFontSizeOn;

    this.tTextViewErrorLabelMarginOn = d3eParams?.tTextViewErrorLabelMarginOn;

    this.tButtonNewResponceOptionButtonDecorationOn =
      d3eParams?.tButtonNewResponceOptionButtonDecorationOn;

    this.tButtonNewResponceOptionButtonTextStyleOn =
      d3eParams?.tButtonNewResponceOptionButtonTextStyleOn;

    this.tButtonNewResponceOptionButtonTextStyleOnHover =
      d3eParams?.tButtonNewResponceOptionButtonTextStyleOnHover;

    this.tButtonPrimaryNewDecorationOn =
      d3eParams?.tButtonPrimaryNewDecorationOn;

    this.tButtonPrimaryNewPaddingOn = d3eParams?.tButtonPrimaryNewPaddingOn;

    this.tButtonPrimaryNewTextStyleOn = d3eParams?.tButtonPrimaryNewTextStyleOn;

    this.tButtonPrimaryNewDecorationOnHover =
      d3eParams?.tButtonPrimaryNewDecorationOnHover;

    this.tButtonPrimaryNewPaddingOnHover =
      d3eParams?.tButtonPrimaryNewPaddingOnHover;

    this.tButtonPrimaryNewTextStyleOnHover =
      d3eParams?.tButtonPrimaryNewTextStyleOnHover;

    this.tButtonResponceOptionButtonPaddingOn =
      d3eParams?.tButtonResponceOptionButtonPaddingOn;

    this.tButtonResponceOptionButtonDecorationOn =
      d3eParams?.tButtonResponceOptionButtonDecorationOn;

    this.tButtonResponceOptionButtonTextStyleOn =
      d3eParams?.tButtonResponceOptionButtonTextStyleOn;

    this.tButtonResponceOptionButtonDecorationOnHover =
      d3eParams?.tButtonResponceOptionButtonDecorationOnHover;

    this.tButtonResponceOptionButtonPaddingOnHover =
      d3eParams?.tButtonResponceOptionButtonPaddingOnHover;

    this.tButtonResponceOptionButtonTextStyleOnHover =
      d3eParams?.tButtonResponceOptionButtonTextStyleOnHover;

    this.tButtonSecondaryDecorationOn = d3eParams?.tButtonSecondaryDecorationOn;

    this.tButtonSecondaryPaddingOn = d3eParams?.tButtonSecondaryPaddingOn;

    this.tButtonSecondaryConstraintsOn =
      d3eParams?.tButtonSecondaryConstraintsOn;

    this.tButtonSecondaryTextStyleOn = d3eParams?.tButtonSecondaryTextStyleOn;

    this.tButtonSecondaryDecorationOnHover =
      d3eParams?.tButtonSecondaryDecorationOnHover;

    this.tButtonSecondaryPaddingOnHover =
      d3eParams?.tButtonSecondaryPaddingOnHover;

    this.tButtonSecondaryConstraintsOnHover =
      d3eParams?.tButtonSecondaryConstraintsOnHover;

    this.tButtonSecondaryTextStyleOnHover =
      d3eParams?.tButtonSecondaryTextStyleOnHover;

    this.tButtonSecondaryNewPaddingOn = d3eParams?.tButtonSecondaryNewPaddingOn;

    this.tButtonSecondaryNewDecorationOn =
      d3eParams?.tButtonSecondaryNewDecorationOn;

    this.tButtonSecondaryNewTextStyleOn =
      d3eParams?.tButtonSecondaryNewTextStyleOn;

    this.tButtonSecondaryNewDecorationOnHover =
      d3eParams?.tButtonSecondaryNewDecorationOnHover;

    this.tButtonSecondaryNewPaddingOnHover =
      d3eParams?.tButtonSecondaryNewPaddingOnHover;

    this.tButtonSecondaryNewTextStyleOnHover =
      d3eParams?.tButtonSecondaryNewTextStyleOnHover;

    this.tTextViewTableCellTextFontSizeOn =
      d3eParams?.tTextViewTableCellTextFontSizeOn;

    this.tTextViewTableCellTextColorOn =
      d3eParams?.tTextViewTableCellTextColorOn;

    this.tTextViewTableCellTextFontFamilyOn =
      d3eParams?.tTextViewTableCellTextFontFamilyOn;

    this.tTextViewTableHeaderFontSizeOn =
      d3eParams?.tTextViewTableHeaderFontSizeOn;

    this.tTextViewTableHeaderColorOn = d3eParams?.tTextViewTableHeaderColorOn;

    this.tTextViewTableHeaderFontFamilyOn =
      d3eParams?.tTextViewTableHeaderFontFamilyOn;

    this.tTableRowTableRowOnebgDecorationOn =
      d3eParams?.tTableRowTableRowOnebgDecorationOn;

    this.tTableRowTableRowOnebgPaddingOn =
      d3eParams?.tTableRowTableRowOnebgPaddingOn;

    this.tTableRowTableRowTwobgDecorationOn =
      d3eParams?.tTableRowTableRowTwobgDecorationOn;

    this.tTableRowTableRowTwobgPaddingOn =
      d3eParams?.tTableRowTableRowTwobgPaddingOn;

    this.c1 = d3eParams?.c1;

    this.c2 = d3eParams?.c2;

    this.c3 = d3eParams?.c3;

    this.c4 = d3eParams?.c4;

    this.c5 = d3eParams?.c5;

    this.c6 = d3eParams?.c6;

    this.c7 = d3eParams?.c7;

    this.c8 = d3eParams?.c8;

    this.c9 = d3eParams?.c9;

    this.c10 = d3eParams?.c10;

    this.c11 = d3eParams?.c11;

    this.c12 = d3eParams?.c12;

    this.c13 = d3eParams?.c13;

    this.c14 = d3eParams?.c14;

    this.c15 = d3eParams?.c15;

    this.c16 = d3eParams?.c16;

    this.c17 = d3eParams?.c17;
  }
  public static createDarkTheme(): StyleThemeData {
    StyleThemeData.DarkTheme = new StyleThemeData({
      themeName: "DarkTheme",
      color: new ui.Color(0xffffffff),
      textStyle: new ui.TextStyle({
        color: new ui.Color(0xffffffff),
        fontFamily: "Open Sans",
        fontSize: 13.0,
      }),
      tooltipBackgroundColor: new ui.Color(0xffffffff),
      tooltipTextColor: new ui.Color(0xff1f2937),
      tTableRowTableBackgroundDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xff1f2937),
        transitions: new Map(),
      }),
      tTableRowTableBackgroundPaddingOn: ui.EdgeInsets.symmetric({
        horizontal: 0.0,
        vertical: 5.0,
        transitions: new Map(),
      }),
      tTableRowTableBackgroundTextStyleOn: new ui.TextStyle({
        color: new ui.Color(0xff91959e),
        fontFamily: "Open Sans",
      }),
      tTableRowTableBackgroundConstraintsOn: new ui.BoxConstraints({
        minWidth: 80.0,
      }),
      tTableCellDefaultCellVerticalAlignmentOn:
        ui.TableCellVerticalAlignment.middle,
      tTableDefaultTableBorderOn: new ui.TableBorder({
        horizontalInside: new ui.BorderSide({
          color: new ui.Color(0xff4d5b75),
          width: 0.5,
          style: ui.BorderStyle.solid,
        }),
        bottom: new ui.BorderSide({
          color: new ui.Color(0xff4d5b75),
          width: 0.5,
          style: ui.BorderStyle.solid,
        }),
      }),
      tButtonButtonWithNoBorderRadiusDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xff000000),
        border: ui.Border.all({ color: new ui.Color(0xff000000), width: 1.0 }),
        transitions: new Map(),
      }),
      tButtonButtonWithNoBorderRadiusHeightOn: 35.0,
      tButtonButtonWithNoBorderRadiusConstraintsOn: new ui.BoxConstraints({
        minWidth: 110.0,
      }),
      tButtonButtonWithNoBorderRadiusTextStyleOn: new ui.TextStyle({
        color: new ui.Color(0xffffffff),
        fontWeight: ui.FontWeight.w500,
        fontSize: 14.0,
        fontFamily: "Open Sans",
      }),
      tButtonButtonWithNoBorderRadiusDecorationOnHover: new ui.BoxDecoration({
        color: new ui.Color(0xff28323f),
        border: ui.Border.all({ color: new ui.Color(0xff28323f), width: 1.0 }),
        transitions: new Map(),
      }),
      tButtonButtonWithNoBorderRadiusTextStyleOnHover: new ui.TextStyle({
        color: new ui.Color(0xffffffff),
        fontWeight: ui.FontWeight.w500,
        fontSize: 14.0,
        fontFamily: "Open Sans",
      }),
      tButtonButtonWithNoBorderRadiusDecorationOnFocus: new ui.BoxDecoration({
        color: new ui.Color(0xff000000),
        border: ui.Border.all({ color: new ui.Color(0xff007acc), width: 1.0 }),
        transitions: new Map(),
      }),
      tButtonButtonWithNoBorderRadiusTextStyleOnFocus: new ui.TextStyle({
        color: new ui.Color(0xffffffff),
        fontWeight: ui.FontWeight.w500,
        fontSize: 14.0,
        fontFamily: "Open Sans",
      }),
      tButtonPrimaryButtonDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xff000000),
        border: ui.Border.all({ color: new ui.Color(0xff000000), width: 2.0 }),
        borderRadius: ui.BorderRadius.circular(5.0),
        transitions: new Map(),
      }),
      tButtonPrimaryButtonPaddingOn: ui.EdgeInsets.all(7.0, new Map()),
      tButtonPrimaryButtonConstraintsOn: new ui.BoxConstraints({
        minWidth: 110.0,
      }),
      tButtonPrimaryButtonTextStyleOn: new ui.TextStyle({
        color: new ui.Color(0xffffffff),
        fontWeight: ui.FontWeight.w500,
        fontSize: 14.0,
        fontFamily: "Open Sans",
      }),
      tButtonPrimaryButtonDecorationOnHover: new ui.BoxDecoration({
        color: new ui.Color(0xff28323f),
        border: ui.Border.all({ color: new ui.Color(0xff28323f), width: 2.0 }),
        borderRadius: ui.BorderRadius.circular(5.0),
        transitions: new Map(),
      }),
      tButtonPrimaryButtonTextStyleOnHover: new ui.TextStyle({
        color: new ui.Color(0xffffffff),
        fontWeight: ui.FontWeight.w500,
        fontSize: 14.0,
        fontFamily: "Open Sans",
      }),
      tButtonPrimaryButtonDecorationOnFocus: new ui.BoxDecoration({
        color: new ui.Color(0x0),
        border: ui.Border.all({ color: new ui.Color(0xff007acc), width: 2.0 }),
        borderRadius: ui.BorderRadius.circular(5.0),
        transitions: new Map(),
      }),
      tButtonPrimaryButtonTextStyleOnFocus: new ui.TextStyle({
        color: new ui.Color(0xff000000),
        fontWeight: ui.FontWeight.w500,
        fontSize: 14.0,
        fontFamily: "Open Sans",
      }),
      tButtonDisabledPrimaryButtonDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xff282d33),
        border: ui.Border.all({ color: new ui.Color(0xff4d5b75), width: 2.0 }),
        borderRadius: ui.BorderRadius.circular(5.0),
        transitions: new Map(),
      }),
      tButtonDisabledPrimaryButtonPaddingOn: ui.EdgeInsets.all(7.0, new Map()),
      tButtonDisabledPrimaryButtonConstraintsOn: new ui.BoxConstraints({
        minWidth: 110.0,
      }),
      tButtonDisabledPrimaryButtonTextStyleOn: new ui.TextStyle({
        color: new ui.Color(0xffffffff),
        fontWeight: ui.FontWeight.w500,
        fontSize: 14.0,
        fontFamily: "Open Sans",
      }),
      tButtonSecondaryButtonPaddingOn: ui.EdgeInsets.all(7.0, new Map()),
      tButtonSecondaryButtonConstraintsOn: new ui.BoxConstraints({
        minWidth: 110.0,
      }),
      tButtonSecondaryButtonDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xff19222f),
        border: ui.Border.all({ width: 2.0, color: new ui.Color(0xff000000) }),
        borderRadius: ui.BorderRadius.circular(5.0),
        transitions: new Map(),
      }),
      tButtonSecondaryButtonTextStyleOn: new ui.TextStyle({
        color: new ui.Color(0xff000000),
        fontWeight: ui.FontWeight.w500,
        fontSize: 14.0,
        fontFamily: "Open Sans",
      }),
      tButtonSecondaryButtonDecorationOnHover: new ui.BoxDecoration({
        border: ui.Border.all({ width: 2.0, color: new ui.Color(0xff000000) }),
        borderRadius: ui.BorderRadius.circular(5.0),
        color: new ui.Color(0xff1f2937),
        transitions: new Map(),
      }),
      tButtonSecondaryButtonTextStyleOnHover: new ui.TextStyle({
        color: new ui.Color(0xff000000),
        fontWeight: ui.FontWeight.w500,
        fontSize: 14.0,
        fontFamily: "Open Sans",
      }),
      tButtonSecondaryButtonDecorationOnFocus: new ui.BoxDecoration({
        color: new ui.Color(0xff19222f),
        border: ui.Border.all({ color: new ui.Color(0xff007acc), width: 2.0 }),
        borderRadius: ui.BorderRadius.circular(5.0),
        transitions: new Map(),
      }),
      tButtonSecondaryButtonTextStyleOnFocus: new ui.TextStyle({
        color: new ui.Color(0xff000000),
        fontWeight: ui.FontWeight.w500,
        fontSize: 14.0,
        fontFamily: "Open Sans",
      }),
      tButtonAddButtonDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xff000000),
        border: ui.Border.all({ color: new ui.Color(0x0), width: 1.0 }),
        borderRadius: ui.BorderRadius.circular(5.0),
        transitions: new Map(),
      }),
      tButtonAddButtonTextStyleOn: new ui.TextStyle({
        color: new ui.Color(0xffffffff),
        fontWeight: ui.FontWeight.w500,
        fontSize: 14.0,
        fontFamily: "Open Sans",
      }),
      tButtonAddButtonHeightOn: 35.0,
      tButtonAddButtonPaddingOn: ui.EdgeInsets.all(7.0, new Map()),
      tButtonAddButtonConstraintsOn: new ui.BoxConstraints({ minWidth: 35.0 }),
      tButtonAddButtonDecorationOnHover: new ui.BoxDecoration({
        color: new ui.Color(0xff28323f),
        border: ui.Border.all({ color: new ui.Color(0xff28323f), width: 1.0 }),
        borderRadius: ui.BorderRadius.circular(5.0),
        transitions: new Map(),
      }),
      tButtonAddButtonTextStyleOnHover: new ui.TextStyle({
        color: new ui.Color(0xffffffff),
        fontWeight: ui.FontWeight.w500,
        fontSize: 14.0,
        fontFamily: "Open Sans",
      }),
      tButtonAddButtonDecorationOnFocus: new ui.BoxDecoration({
        color: new ui.Color(0xff000000),
        border: ui.Border.all({ color: new ui.Color(0xff007acc), width: 1.0 }),
        borderRadius: ui.BorderRadius.circular(5.0),
        transitions: new Map(),
      }),
      tButtonAddButtonTextStyleOnFocus: new ui.TextStyle({
        color: new ui.Color(0xff000000),
        fontWeight: ui.FontWeight.w500,
        fontSize: 14.0,
        fontFamily: "Open Sans",
      }),
      tButtonDeleteButtonDecorationOnHover: new ui.BoxDecoration({
        color: new ui.Color(0xfff9746d),
        border: ui.Border.all({ color: new ui.Color(0xfff9746d), width: 2.0 }),
        borderRadius: ui.BorderRadius.circular(5.0),
        transitions: new Map(),
      }),
      tButtonDeleteButtonTextStyleOnHover: new ui.TextStyle({
        color: new ui.Color(0xffffffff),
        fontWeight: ui.FontWeight.w500,
        fontSize: 14.0,
        fontFamily: "Open Sans",
      }),
      tButtonDeleteButtonDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xff5d1821),
        border: ui.Border.all({ color: new ui.Color(0xfff9746d), width: 2.0 }),
        borderRadius: ui.BorderRadius.circular(5.0),
        transitions: new Map(),
      }),
      tButtonDeleteButtonPaddingOn: ui.EdgeInsets.all(7.0, new Map()),
      tButtonDeleteButtonConstraintsOn: new ui.BoxConstraints({
        minWidth: 110.0,
      }),
      tButtonDeleteButtonTextStyleOn: new ui.TextStyle({
        color: new ui.Color(0xfff9746d),
        fontWeight: ui.FontWeight.w500,
        fontSize: 14.0,
        fontFamily: "Open Sans",
      }),
      tButtonDeleteButtonDecorationOnFocus: new ui.BoxDecoration({
        color: new ui.Color(0xff5d1821),
        border: ui.Border.all({ color: new ui.Color(0xff007acc), width: 2.0 }),
        borderRadius: ui.BorderRadius.circular(5.0),
        transitions: new Map(),
      }),
      tButtonDeleteButtonTextStyleOnFocus: new ui.TextStyle({
        color: new ui.Color(0xfff9746d),
        fontWeight: ui.FontWeight.w500,
        fontSize: 14.0,
        fontFamily: "Open Sans",
      }),
      tTextViewListTileTextFontSizeOn: 13.0,
      tTextViewListTileTextFontWeightOn: ui.FontWeight.w500,
      tTextViewListTileTextColorOn: new ui.Color(0xffffffff),
      tTextViewListTileTextOverflowOn: ui.TextOverflow.ellipsis,
      tTextViewListTileTextOnLightBackgroundFontSizeOn: 13.0,
      tTextViewListTileTextOnLightBackgroundFontWeightOn: ui.FontWeight.w500,
      tTextViewListTileTextOnLightBackgroundColorOn: new ui.Color(0xff99a8bd),
      tTextViewBoldHeadingFontSizeOn: 30.0,
      tTextViewBoldHeadingFontWeightOn: ui.FontWeight.w700,
      tTextViewBoldHeadingColorOn: new ui.Color(0xff91959e),
      tTextViewBoldHeadingPaddingOn: ui.EdgeInsets.fromLTRB(
        0.0,
        15.0,
        0.0,
        20.0,
        new Map()
      ),
      tTextViewHeadingFontSizeOn: 20.0,
      tTextViewHeadingFontWeightOn: ui.FontWeight.w600,
      tTextViewHeadingTextAlignOn: ui.TextAlign.start,
      tTextViewHeadingColorOn: new ui.Color(0xff91959e),
      tTextViewParagraphHeadingFontSizeOn: 18.0,
      tTextViewParagraphHeadingFontWeightOn: ui.FontWeight.w400,
      tTextViewParagraphHeadingTextAlignOn: ui.TextAlign.start,
      tTextViewParagraphHeadingColorOn: new ui.Color(0xff91959e),
      tTextViewParagraphHeadingPaddingOn: ui.EdgeInsets.symmetric({
        horizontal: 0.0,
        vertical: 20.0,
        transitions: new Map(),
      }),
      tCheckboxActiveCheckboxActiveColorOn: new ui.Color(0xff000000),
      tIconButtonIconButtonDefaultColorOn: new ui.Color(0xff28323f),
      tIconButtonIconButtonDefaultHoverColorOn: new ui.Color(0xff007acc),
      tIconViewIconViewDefaultColorOn: new ui.Color(0xff28323f),
      tIconViewIconViewDefaultColorOnHover: new ui.Color(0xff007acc),
      tIconViewIconViewDefaultColorOnFocus: new ui.Color(0xff007acc),
      tTextViewTitleFontSizeOn: 15.0,
      tTextViewTitleColorOn: new ui.Color(0xff91959e),
      tTextViewTitleFontWeightOn: ui.FontWeight.w600,
      tTextViewTitleTextAlignOn: ui.TextAlign.start,
      tRowSuccessBackgroundDecorationOn: new ui.BoxDecoration({
        borderRadius: ui.BorderRadius.circular(3.0),
        color: new ui.Color(0xff00875a),
        border: ui.Border.all({ color: new ui.Color(0xff4d5b75), width: 1.5 }),
        transitions: new Map(),
      }),
      tRowSuccessBackgroundPaddingOn: ui.EdgeInsets.symmetric({
        horizontal: 10.0,
        vertical: 5.0,
        transitions: new Map(),
      }),
      tTextViewSuccessErrorTextFontSizeOn: 15.0,
      tTextViewSuccessErrorTextTextAlignOn: ui.TextAlign.start,
      tTextViewSuccessErrorTextColorOn: new ui.Color(0xffffffff),
      tTextViewErrorMessageColorOn: new ui.Color(0xfff9746d),
      tTextViewErrorMessageFontSizeOn: 12.0,
      tTextViewErrorMessageTextAlignOn: ui.TextAlign.start,
      tTextViewListTextFontSizeOn: 13.0,
      tTextViewListTextColorOn: new ui.Color(0xff91959e),
      tTextViewListTextTextAlignOn: ui.TextAlign.start,
      tTextViewListTextOverflowOn: ui.TextOverflow.ellipsis,
      tTextViewLabelTextColorOn: new ui.Color(0xff91959e),
      tTextViewLabelTextTextAlignOn: ui.TextAlign.start,
      tTextViewLabelTextFontSizeOn: 13.0,
      tTextViewLabelTextFontWeightOn: ui.FontWeight.w600,
      tBaseBackgroundColorDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xff1f2937),
        transitions: new Map(),
      }),
      tBaseBackgroundColorColumnDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xff1f2937),
        transitions: new Map(),
      }),
      tBaseBackgroundColorColumnPaddingOn: ui.EdgeInsets.fromLTRB(
        20.0,
        20.0,
        0.0,
        20.0,
        new Map()
      ),
      tTextViewParagraphTextFontSizeOn: 13.0,
      tTextViewParagraphTextFontWeightOn: ui.FontWeight.w400,
      tTextViewParagraphTextColorOn: new ui.Color(0xffd9dadd),
      tTextViewColoredTextColorOn: new ui.Color(0xff007acc),
      tTextViewColoredTextFontSizeOn: 13.0,
      tTextViewColoredTextTextDecorationOnHover: ui.TextDecoration.underline,
      tTextViewParagraphCenterFontSizeOn: 13.0,
      tTextViewParagraphCenterTextAlignOn: ui.TextAlign.center,
      tTextViewParagraphCenterColorOn: new ui.Color(0xffd9dadd),
      tTextViewParagraphCenterPaddingOn: ui.EdgeInsets.zero,
      tTextViewTextOverFlowFontSizeOn: 13.0,
      tTextViewTextOverFlowMaxLinesOn: 2,
      tTextViewTextOverFlowTextAlignOn: ui.TextAlign.center,
      tTextViewTextOverFlowOverflowOn: ui.TextOverflow.ellipsis,
      tInputFieldNormalInputfieldHeightOn: 35.0,
      tInputFieldNormalInputfieldWidthOn: 400.0,
      tInputFieldNormalInputfieldBackgroundColorOn: new ui.Color(0xff19222f),
      tInputFieldNormalInputfieldCornerRadiusOn: 0.0,
      tInputFieldNormalInputfieldCursorColorOn: new ui.Color(0xff007acc),
      tInputFieldNormalInputfieldInActiveColorOn: new ui.Color(0xff4d5b75),
      tInputFieldNormalInputfieldPlaceHolderColorOn: new ui.Color(0xffd9dadd),
      tInputFieldNormalInputfieldStyleOn: new ui.TextStyle({
        color: new ui.Color(0xff91959e),
        fontFamily: "Open Sans",
      }),
      tInputFieldSmallNormalInputfieldHeightOn: 35.0,
      tInputFieldSmallNormalInputfieldWidthOn: 360.0,
      tInputFieldSmallNormalInputfieldBackgroundColorOn: new ui.Color(
        0xff19222f
      ),
      tInputFieldSmallNormalInputfieldCornerRadiusOn: 3.0,
      tInputFieldSmallNormalInputfieldCursorColorOn: new ui.Color(0xff007acc),
      tInputFieldSmallNormalInputfieldInActiveColorOn: new ui.Color(0xff4d5b75),
      tInputFieldSmallNormalInputfieldPlaceHolderColorOn: new ui.Color(
        0xffd9dadd
      ),
      tInputFieldSmallNormalInputfieldStyleOn: new ui.TextStyle({
        color: new ui.Color(0xff91959e),
        fontFamily: "Open Sans",
      }),
      tInputFieldTestDataInputfieldHeightOn: 35.0,
      tInputFieldTestDataInputfieldWidthOn: 150.0,
      tInputFieldTestDataInputfieldBackgroundColorOn: new ui.Color(0xff19222f),
      tInputFieldTestDataInputfieldCornerRadiusOn: 5.0,
      tInputFieldTestDataInputfieldCursorColorOn: new ui.Color(0xff007acc),
      tInputFieldTestDataInputfieldStyleOn: new ui.TextStyle({
        color: new ui.Color(0xff91959e),
        fontFamily: "Open Sans",
      }),
      tInputFieldDisabledInputfieldWidthOn: 400.0,
      tInputFieldDisabledInputfieldHeightOn: 35.0,
      tInputFieldDisabledInputfieldBackgroundColorOn: new ui.Color(0xff282d33),
      tInputFieldDisabledInputfieldStyleOn: new ui.TextStyle({
        color: new ui.Color(0xff91959e),
        fontFamily: "Open Sans",
      }),
      tInputFieldDisabledInputfieldDisableOn: true,
      tInputFieldDisabledInputfieldDecorationOn: new ui.BoxDecoration({
        border: ui.Border.all({ color: new ui.Color(0xff4d5b75) }),
        borderRadius: ui.BorderRadius.circular(5.0),
        transitions: new Map(),
      }),
      tInputFieldSmallDisabledInputfieldWidthOn: 360.0,
      tInputFieldSmallDisabledInputfieldHeightOn: 35.0,
      tInputFieldSmallDisabledInputfieldBackgroundColorOn: new ui.Color(
        0xff282d33
      ),
      tInputFieldSmallDisabledInputfieldStyleOn: new ui.TextStyle({
        color: new ui.Color(0xff91959e),
        fontFamily: "Open Sans",
      }),
      tInputFieldSmallDisabledInputfieldDisableOn: true,
      tInputFieldSmallDisabledInputfieldDecorationOn: new ui.BoxDecoration({
        border: ui.Border.all({ color: new ui.Color(0xff4d5b75) }),
        borderRadius: ui.BorderRadius.circular(5.0),
        transitions: new Map(),
      }),
      tInputFieldSearchInputfieldInActiveColorOn: new ui.Color(0xff19222f),
      tInputFieldSearchInputfieldPlaceHolderColorOn: new ui.Color(0xffd9dadd),
      tInputFieldSearchInputfieldActiveColorOn: new ui.Color(0xff19222f),
      tInputFieldSearchInputfieldPaddingOn: ui.EdgeInsets.fromLTRB(
        0.0,
        4.0,
        2.0,
        4.0,
        new Map()
      ),
      tInputFieldDescriptionInputfieldHeightOn: 90.0,
      tInputFieldDescriptionInputfieldWidthOn: 400.0,
      tInputFieldDescriptionInputfieldCornerRadiusOn: 5.0,
      tInputFieldDescriptionInputfieldBackgroundColorOn: new ui.Color(
        0xff19222f
      ),
      tInputFieldDescriptionInputfieldPlaceHolderColorOn: new ui.Color(
        0xffd9dadd
      ),
      tInputFieldDescriptionInputfieldStyleOn: new ui.TextStyle({
        color: new ui.Color(0xff91959e),
        fontFamily: "Open Sans",
      }),
      tBasePanelColorWithBorderDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xff000000),
        border: new ui.Border({
          right: new ui.BorderSide({
            color: new ui.Color(0xff4d5b75),
            width: 1.0,
          }),
        }),
        transitions: new Map(),
      }),
      tTextViewDropDownBuilderTextColorOn: new ui.Color(0xff99a8bd),
      tTextViewDropDownBuilderTextPaddingOn: ui.EdgeInsets.fromLTRB(
        5.0,
        4.0,
        0.0,
        4.0,
        new Map()
      ),
      tDropDownRoundRadiusDropDownHeightOn: 35.0,
      tDropDownRoundRadiusDropDownOnHoverColorOn: new ui.Color(0xff253140),
      tDropDownRoundRadiusDropDownPlaceHolderColorOn: new ui.Color(0xffd9dadd),
      tDropDownRoundRadiusDropDownDropDownDecorationOn: new ui.BoxDecoration({
        border: ui.Border.all({ color: new ui.Color(0xff4d5b75), width: 1.0 }),
        borderRadius: ui.BorderRadius.circular(3.0),
        color: new ui.Color(0xff19222f),
        transitions: new Map(),
      }),
      tDropDownRoundRadiusDropDownViewDecorationOn: new ui.BoxDecoration({
        border: new ui.Border({
          right: new ui.BorderSide({
            color: new ui.Color(0xff4d5b75),
            width: 1.0,
          }),
          left: new ui.BorderSide({
            color: new ui.Color(0xff4d5b75),
            width: 1.0,
          }),
          bottom: new ui.BorderSide({
            color: new ui.Color(0xff4d5b75),
            width: 1.0,
          }),
        }),
        color: new ui.Color(0xff19222f),
        transitions: new Map(),
      }),
      tBasePrimaryListTileDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xff000000),
        border: new ui.Border({
          bottom: new ui.BorderSide({ color: new ui.Color(0x0), width: 2.0 }),
        }),
        transitions: new Map(),
      }),
      tBasePrimaryListTileTextStyleOn: new ui.TextStyle({
        color: new ui.Color(0xffffffff),
        fontFamily: "Open Sans",
      }),
      tBasePrimaryListTileDecorationOnHover: new ui.BoxDecoration({
        color: new ui.Color(0xff28323f),
        border: new ui.Border({
          bottom: new ui.BorderSide({ color: new ui.Color(0x0), width: 2.0 }),
        }),
        transitions: new Map(),
      }),
      tBasePrimaryListTileTextStyleOnHover: new ui.TextStyle({
        color: new ui.Color(0xffffffff),
        fontFamily: "Open Sans",
      }),
      tBasePrimaryListTileDecorationOnFocus: new ui.BoxDecoration({
        border: ui.Border.all({ color: new ui.Color(0xff007acc), width: 1.0 }),
        transitions: new Map(),
      }),
      tBasePrimaryListTileDecorationOnSelected: new ui.BoxDecoration({
        color: new ui.Color(0xff28323f),
        border: new ui.Border({
          bottom: new ui.BorderSide({
            color: new ui.Color(0xff19222f),
            width: 2.0,
          }),
        }),
        transitions: new Map(),
      }),
      tBasePrimaryListTileTextStyleOnSelected: new ui.TextStyle({
        color: new ui.Color(0xffffffff),
        fontFamily: "Open Sans",
      }),
      tBasePrimaryListTileDecorationOnHoverSelected: new ui.BoxDecoration({
        color: new ui.Color(0xff28323f),
        border: new ui.Border({
          bottom: new ui.BorderSide({
            color: new ui.Color(0xff19222f),
            width: 1.0,
          }),
        }),
        transitions: new Map(),
      }),
      tBasePrimaryListTileTextStyleOnHoverSelected: new ui.TextStyle({
        color: new ui.Color(0xffffffff),
        fontFamily: "Open Sans",
      }),
      tBaseExpEditorStyleDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xff19222f),
        transitions: new Map(),
      }),
      tBaseDarkBackgroundDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xff000000),
        transitions: new Map(),
      }),
      tBaseDarkBackgroundTextStyleOn: new ui.TextStyle({
        color: new ui.Color(0xffffffff),
        fontFamily: "Open Sans",
      }),
      tContainerLinearGradiantWidthOn: 100.0,
      tContainerLinearGradiantHeightOn: 100.0,
      tContainerLinearGradiantDecorationOn: new ui.BoxDecoration({
        gradient: new ui.LinearGradient({
          colors: [new ui.Color(0xff99a8bd), new ui.Color(0xff19222f)],
        }),
        transitions: new Map(),
      }),
      tBaseSweepGradiantWidthOn: 100.0,
      tBaseSweepGradiantHeightOn: 100.0,
      tBaseSweepGradiantDecorationOn: new ui.BoxDecoration({
        gradient: new ui.SweepGradient({
          colors: [new ui.Color(0xff99a8bd), new ui.Color(0xff19222f)],
        }),
        transitions: new Map(),
      }),
      tContainerRadiualGradiantWidthOn: 100.0,
      tContainerRadiualGradiantHeightOn: 100.0,
      tContainerRadiualGradiantDecorationOn: new ui.BoxDecoration({
        gradient: new ui.RadialGradient({
          colors: [new ui.Color(0xff99a8bd), new ui.Color(0xff19222f)],
        }),
        transitions: new Map(),
      }),
      tButtonUnderlineButtonTextStyleOn: new ui.TextStyle({
        color: new ui.Color(0xff007acc),
        fontSize: 13.0,
        fontWeight: ui.FontWeight.w600,
        fontFamily: "Open Sans",
      }),
      tButtonUnderlineButtonTextStyleOnHover: new ui.TextStyle({
        decoration: ui.TextDecoration.underline,
        color: new ui.Color(0xff007acc),
        fontSize: 13.0,
        fontWeight: ui.FontWeight.w600,
        fontFamily: "Open Sans",
      }),
      tButtonUnderlineButtonTextStyleOnFocusHover: new ui.TextStyle({
        decoration: ui.TextDecoration.underline,
        color: new ui.Color(0xff007acc),
        fontSize: 13.0,
        fontWeight: ui.FontWeight.w600,
        fontFamily: "Open Sans",
      }),
      tButtonUnderlineButtonDecorationOnFocus: new ui.BoxDecoration({
        color: new ui.Color(0xff19222f),
        border: ui.Border.all({ width: 1.0, color: new ui.Color(0xff007acc) }),
        transitions: new Map(),
      }),
      tButtonUnderlineButtonTextStyleOnFocus: new ui.TextStyle({
        decoration: ui.TextDecoration.underline,
        color: new ui.Color(0xff007acc),
        fontSize: 13.0,
        fontWeight: ui.FontWeight.w600,
        fontFamily: "Open Sans",
      }),
      tButtonBoldUnderlineButtonTextStyleOn: new ui.TextStyle({
        color: new ui.Color(0xff007acc),
        fontSize: 20.0,
        fontWeight: ui.FontWeight.w500,
        fontFamily: "Open Sans",
      }),
      tButtonBoldUnderlineButtonTextStyleOnHover: new ui.TextStyle({
        decoration: ui.TextDecoration.underline,
        color: new ui.Color(0xff007acc),
        fontSize: 20.0,
        fontWeight: ui.FontWeight.w500,
        fontFamily: "Open Sans",
      }),
      tButtonBoldUnderlineButtonTextStyleOnFocus: new ui.TextStyle({
        decoration: ui.TextDecoration.underline,
        color: new ui.Color(0xff007acc),
        fontSize: 20.0,
        fontWeight: ui.FontWeight.w500,
        fontFamily: "Open Sans",
      }),
      tButtonBoldUnderlineButtonTextStyleOnFocusHover: new ui.TextStyle({
        decoration: ui.TextDecoration.underline,
        color: new ui.Color(0xff007acc),
        fontSize: 20.0,
        fontWeight: ui.FontWeight.w500,
        fontFamily: "Open Sans",
      }),
      tSearchComponentSearchFieldDecorationOn: new ui.BoxDecoration({
        border: ui.Border.all({ color: new ui.Color(0xff4d5b75), width: 1.0 }),
        borderRadius: ui.BorderRadius.circular(10.0),
        transitions: new Map(),
      }),
      tSearchComponentSearchFieldDecorationOnFocus: new ui.BoxDecoration({
        border: ui.Border.all({ color: new ui.Color(0xff4d5b75), width: 1.0 }),
        borderRadius: ui.BorderRadius.circular(10.0),
        transitions: new Map(),
      }),
      tCheckboxWithTextActiveCheckboxWithTextActiveColorOn: new ui.Color(
        0xff000000
      ),
      tDoubleInputFieldTestDoubleInputFieldHeightOn: 35.0,
      tDoubleInputFieldTestDoubleInputFieldWidthOn: 150.0,
      tDoubleInputFieldTestDoubleInputFieldBackgroundColorOn: new ui.Color(
        0xff19222f
      ),
      tDoubleInputFieldTestDoubleInputFieldCornerRadiusOn: 5.0,
      tIntegerInputFieldTestIntegerInputFieldHeightOn: 35.0,
      tIntegerInputFieldTestIntegerInputFieldWidthOn: 150.0,
      tIntegerInputFieldTestIntegerInputFieldBackgroundColorOn: new ui.Color(
        0xff19222f
      ),
      tIntegerInputFieldTestIntegerInputFieldCornerRadiusOn: 5.0,
      tAutoSearchTextWithBuilderAutoRoundRadiusDropDownHeightOn: 35.0,
      tAutoSearchTextWithBuilderAutoRoundRadiusDropDownViewDecorationOn:
        new ui.BoxDecoration({
          border: new ui.Border({
            right: new ui.BorderSide({
              color: new ui.Color(0xff4d5b75),
              width: 1.0,
            }),
            left: new ui.BorderSide({
              color: new ui.Color(0xff4d5b75),
              width: 1.0,
            }),
            bottom: new ui.BorderSide({
              color: new ui.Color(0xff4d5b75),
              width: 1.0,
            }),
          }),
          color: new ui.Color(0xff19222f),
          transitions: new Map(),
        }),
      tAutoSearchTextWithBuilderAutoRoundRadiusDropDownDecorationOn:
        new ui.BoxDecoration({
          color: new ui.Color(0xff19222f),
          border: ui.Border.all({
            color: new ui.Color(0xff4d5b75),
            width: 1.0,
          }),
          borderRadius: ui.BorderRadius.circular(3.0),
          transitions: new Map(),
        }),
      tInputFieldInputBasicBackgroundColorOn: new ui.Color(0xff19222f),
      tInputFieldInputBasicCornerRadiusOn: 3.0,
      tInputFieldInputBasicDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xff19222f),
        border: ui.Border.all({ width: 1.0, color: new ui.Color(0xff4d5b75) }),
        borderRadius: ui.BorderRadius.circular(3.0),
        transitions: new Map(),
      }),
      tInputFieldFixedInputFieldBackgroundColorOn: new ui.Color(0xff19222f),
      tInputFieldFixedInputFieldCornerRadiusOn: 3.0,
      tInputFieldFixedInputFieldDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xff19222f),
        borderRadius: ui.BorderRadius.circular(3.0),
        transitions: new Map(),
      }),
      tBaseCardDecorationOn: new ui.BoxDecoration({
        border: ui.Border.all({ color: new ui.Color(0xff4d5b75), width: 2.0 }),
        boxShadow: [
          new ui.BoxShadow({
            color: new ui.Color(0xff19222f),
            blurRadius: 1.0,
            spreadRadius: 2.0,
          }),
        ],
        borderRadius: ui.BorderRadius.circular(3.0),
        transitions: new Map(),
      }),
      tBaseDefaultPopUpDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xff19222f),
        borderRadius: ui.BorderRadius.circular(2.0),
        boxShadow: [
          new ui.BoxShadow({
            color: new ui.Color(0x32000000),
            blurRadius: 5.0,
          }),
        ],
        transitions: new Map(),
      }),
      tTextViewCollapsableHeaderTextColorOn: new ui.Color(0xff91959e),
      tTextViewCollapsableHeaderTextFontSizeOn: 16.0,
      tTextViewCollapsableHeaderTextFontWeightOn: ui.FontWeight.w600,
      tBaseToolTipDecorationDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xff000000),
        border: ui.Border.all({ color: new ui.Color(0xff4d5b75), width: 1.0 }),
        borderRadius: ui.BorderRadius.circular(3.0),
        transitions: new Map(),
      }),
      tBaseToolTipDecorationPaddingOn: ui.EdgeInsets.all(12.0, new Map()),
      tBaseToolTipDecorationTextStyleOn: new ui.TextStyle({
        color: new ui.Color(0xffffffff),
        fontSize: 10.0,
        fontFamily: "Open Sans",
      }),
      tTableRowTableRowHeadingDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xff1f2937),
        border: new ui.Border({
          bottom: new ui.BorderSide({ color: new ui.Color(0xff4d5b75) }),
        }),
        borderRadius: ui.BorderRadiusExt.only({
          topLeft: ui.RadiusExt.elliptical({ x: 3.0, y: 3.0 }),
          topRight: ui.RadiusExt.elliptical({ x: 3.0, y: 3.0 }),
        }),
        transitions: new Map(),
      }),
      tBaseBackgroundColorColumn2DecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xff19222f),
        transitions: new Map(),
      }),
      tBaseBackgroundColorColumn2PaddingOn: ui.EdgeInsets.symmetric({
        horizontal: 0.0,
        vertical: 5.0,
        transitions: new Map(),
      }),
      tEditTextFieldNormalEditTextFieldHeightOn: 35.0,
      tEditTextFieldNormalEditTextFieldWidthOn: 400.0,
      tEditTextFieldNormalEditTextFieldDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xff19222f),
        border: ui.Border.all({ color: new ui.Color(0xff4d5b75), width: 1.0 }),
        borderRadius: ui.BorderRadius.circular(5.0),
        transitions: new Map(),
      }),
      tCheckboxWitheLabelActiveCheckboxWithLabelActiveColorOn: new ui.Color(
        0xff000000
      ),
      tContainerDropAreaHeightOn: 10.0,
      tContainerDropAreaHeightOnHover: 20.0,
      tContainerDropAreaDecorationOnHover: new ui.BoxDecoration({
        color: new ui.Color(0xff19222f),
        border: ui.Border.all({ width: 1.0, color: new ui.Color(0xff262c34) }),
        transitions: new Map(),
      }),
      tBaseSelectedTabContainerHeightOn: 2.5,
      tBaseSelectedTabContainerWidthOn: 35.0,
      tBaseSelectedTabContainerDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xff000000),
        borderRadius: ui.BorderRadius.circular(5.0),
        transitions: new Map(),
      }),
      tTextViewTabsFontSizeOn: 14.0,
      tTextViewTabsFontWeightOn: ui.FontWeight.w600,
      tRowChatBoxDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0x0),
        border: ui.Border.all({ color: new ui.Color(0x0), width: 1.0 }),
        borderRadius: ui.BorderRadius.circular(50.0),
        transitions: new Map(),
      }),
      tRowChatBoxPaddingOn: ui.EdgeInsets.all(15.0, new Map()),
      tColumnTemplateCardPaddingOn: ui.EdgeInsets.all(5.0, new Map()),
      tColumnTemplateCardDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xffffffff),
        border: ui.Border.all({ color: new ui.Color(0xffdcdcdc), width: 1.0 }),
        borderRadius: ui.BorderRadius.circular(3.0),
        transitions: new Map(),
      }),
      tButtonBtnLinkDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xffffffff),
        border: ui.Border.all({ color: new ui.Color(0xffffffff), width: 1.0 }),
        borderRadius: ui.BorderRadius.circular(3.0),
        transitions: new Map(),
      }),
      tButtonBtnLinkTextStyleOn: new ui.TextStyle({
        decoration: ui.TextDecoration.underline,
        color: new ui.Color(0xff0d6efd),
        fontFamily: "Open Sans",
      }),
      tButtonBtnLinkTextStyleOnHover: new ui.TextStyle({
        color: new ui.Color(0xff0a58ca),
        fontFamily: "Open Sans",
      }),
      tTextViewHeadlineThreeFontSizeOn: 10.0,
      tTextViewHeadlineThreeFontWeightOn: ui.FontWeight.bold,
      tTextViewLabelColorOn: new ui.Color(0xff00875a),
      tTextViewLabelTextAlignOn: ui.TextAlign.start,
      tTextViewLabelMarginOn: ui.EdgeInsets.symmetric({
        horizontal: 0.0,
        vertical: 5.0,
        transitions: new Map(),
      }),
      tButtonOutlineButtonDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xffffffff),
        border: ui.Border.all({ color: new ui.Color(0xffdcdcdc), width: 1.0 }),
        borderRadius: ui.BorderRadius.circular(3.0),
        transitions: new Map(),
      }),
      tButtonOutlineButtonTextStyleOn: new ui.TextStyle({
        fontFamily: "Open Sans",
        fontSize: 16.0,
      }),
      tButtonOutlineButtonPaddingOn: ui.EdgeInsets.all(5.0, new Map()),
      tTextViewErrorLabelColorOn: new ui.Color(0xffe71306),
      tTextViewErrorLabelFontFamilyOn: "Open Sans",
      tTextViewErrorLabelFontSizeOn: 14.0,
      tTextViewErrorLabelMarginOn: ui.EdgeInsets.fromLTRB(
        0.0,
        5.0,
        0.0,
        0.0,
        new Map()
      ),
      tButtonNewResponceOptionButtonDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xffffffff),
        border: ui.Border.all({ color: new ui.Color(0xffffffff), width: 1.0 }),
        borderRadius: ui.BorderRadius.circular(3.0),
        transitions: new Map(),
      }),
      tButtonNewResponceOptionButtonTextStyleOn: new ui.TextStyle({
        color: new ui.Color(0xff0d6efd),
        fontFamily: "Open Sans",
      }),
      tButtonNewResponceOptionButtonTextStyleOnHover: new ui.TextStyle({
        decoration: ui.TextDecoration.underline,
        color: new ui.Color(0xff0a58ca),
        fontFamily: "Open Sans",
      }),
      tButtonPrimaryNewDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xff0f6cbd),
        border: ui.Border.all({ color: new ui.Color(0xff0f6cbd), width: 1.0 }),
        borderRadius: ui.BorderRadius.circular(3.0),
        transitions: new Map(),
      }),
      tButtonPrimaryNewPaddingOn: ui.EdgeInsets.all(10.0, new Map()),
      tButtonPrimaryNewTextStyleOn: new ui.TextStyle({
        fontFamily: "Open Sans",
        fontSize: 16.0,
        fontWeight: ui.FontWeight.w500,
        color: new ui.Color(0xffffffff),
      }),
      tButtonPrimaryNewDecorationOnHover: new ui.BoxDecoration({
        color: new ui.Color(0xff1f86df),
        border: ui.Border.all({ color: new ui.Color(0xff0f6cbd), width: 1.0 }),
        borderRadius: ui.BorderRadius.circular(3.0),
        transitions: new Map(),
      }),
      tButtonPrimaryNewPaddingOnHover: ui.EdgeInsets.all(10.0, new Map()),
      tButtonPrimaryNewTextStyleOnHover: new ui.TextStyle({
        fontFamily: "Open Sans",
        fontSize: 16.0,
        fontWeight: ui.FontWeight.w500,
        color: new ui.Color(0xffffffff),
      }),
      tButtonResponceOptionButtonPaddingOn: ui.EdgeInsets.all(3.0, new Map()),
      tButtonResponceOptionButtonDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xffffffff),
        border: ui.Border.all({ color: new ui.Color(0xff0f6cbd), width: 1.0 }),
        borderRadius: ui.BorderRadius.circular(3.0),
        transitions: new Map(),
      }),
      tButtonResponceOptionButtonTextStyleOn: new ui.TextStyle({
        fontFamily: "Open Sans",
        fontSize: 10.0,
        color: new ui.Color(0xff0f6cbd),
      }),
      tButtonResponceOptionButtonDecorationOnHover: new ui.BoxDecoration({
        color: new ui.Color(0xff0f6cbd),
        border: ui.Border.all({ color: new ui.Color(0xff0f6cbd), width: 1.0 }),
        borderRadius: ui.BorderRadius.circular(3.0),
        transitions: new Map(),
      }),
      tButtonResponceOptionButtonPaddingOnHover: ui.EdgeInsets.all(
        3.0,
        new Map()
      ),
      tButtonResponceOptionButtonTextStyleOnHover: new ui.TextStyle({
        fontFamily: "Open Sans",
        fontSize: 10.0,
        color: new ui.Color(0xffffffff),
      }),
      tButtonSecondaryDecorationOn: new ui.BoxDecoration({
        border: ui.Border.all({ color: new ui.Color(0xff13aed9), width: 1.0 }),
        borderRadius: ui.BorderRadius.circular(3.0),
        color: new ui.Color(0xffffffff),
        transitions: new Map(),
      }),
      tButtonSecondaryPaddingOn: ui.EdgeInsets.all(7.0, new Map()),
      tButtonSecondaryConstraintsOn: new ui.BoxConstraints({ minHeight: 30.0 }),
      tButtonSecondaryTextStyleOn: new ui.TextStyle({
        color: new ui.Color(0xff46b4f1),
        fontFamily: "Open Sans",
      }),
      tButtonSecondaryDecorationOnHover: new ui.BoxDecoration({
        border: ui.Border.all({ color: new ui.Color(0xff13aed9), width: 1.0 }),
        borderRadius: ui.BorderRadius.circular(3.0),
        color: new ui.Color(0xffdcdcdc),
        transitions: new Map(),
      }),
      tButtonSecondaryPaddingOnHover: ui.EdgeInsets.all(7.0, new Map()),
      tButtonSecondaryConstraintsOnHover: new ui.BoxConstraints({
        minHeight: 30.0,
      }),
      tButtonSecondaryTextStyleOnHover: new ui.TextStyle({
        color: new ui.Color(0xff46b4f1),
        fontFamily: "Open Sans",
      }),
      tButtonSecondaryNewPaddingOn: ui.EdgeInsets.all(10.0, new Map()),
      tButtonSecondaryNewDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xffffffff),
        border: ui.Border.all({ color: new ui.Color(0xff0f6cbd), width: 1.0 }),
        borderRadius: ui.BorderRadius.circular(3.0),
        transitions: new Map(),
      }),
      tButtonSecondaryNewTextStyleOn: new ui.TextStyle({
        fontFamily: "Open Sans",
        fontSize: 16.0,
        fontWeight: ui.FontWeight.w500,
        color: new ui.Color(0xff0f6cbd),
      }),
      tButtonSecondaryNewDecorationOnHover: new ui.BoxDecoration({
        color: new ui.Color(0xfff3f6f9),
        border: ui.Border.all({ color: new ui.Color(0xff0f6cbd), width: 1.0 }),
        borderRadius: ui.BorderRadius.circular(3.0),
        transitions: new Map(),
      }),
      tButtonSecondaryNewPaddingOnHover: ui.EdgeInsets.all(10.0, new Map()),
      tButtonSecondaryNewTextStyleOnHover: new ui.TextStyle({
        fontFamily: "Open Sans",
        fontSize: 16.0,
        fontWeight: ui.FontWeight.w500,
        color: new ui.Color(0xff0f6cbd),
      }),
      tTextViewTableCellTextFontSizeOn: 16.0,
      tTextViewTableCellTextColorOn: new ui.Color(0xff000000),
      tTextViewTableCellTextFontFamilyOn: "Open Sans",
      tTextViewTableHeaderFontSizeOn: 16.0,
      tTextViewTableHeaderColorOn: new ui.Color(0xff000000),
      tTextViewTableHeaderFontFamilyOn: "Open Sans",
      tTableRowTableRowOnebgDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xfff3f6f9),
        border: new ui.Border({
          bottom: new ui.BorderSide({
            color: new ui.Color(0xff0f6cbd),
            width: 0.5,
            style: ui.BorderStyle.solid,
          }),
        }),
        transitions: new Map(),
      }),
      tTableRowTableRowOnebgPaddingOn: ui.EdgeInsets.all(10.0, new Map()),
      tTableRowTableRowTwobgDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xffffffff),
        border: new ui.Border({
          bottom: new ui.BorderSide({
            color: new ui.Color(0xff0f6cbd),
            width: 0.5,
            style: ui.BorderStyle.solid,
          }),
        }),
        transitions: new Map(),
      }),
      tTableRowTableRowTwobgPaddingOn: ui.EdgeInsets.all(10.0, new Map()),
      c1: new ui.Color(0xff99a8bd),
      c2: new ui.Color(0xff19222f),
      c3: new ui.Color(0xff000000),
      c4: new ui.Color(0xff28323f),
      c5: new ui.Color(0xff007acc),
      c6: new ui.Color(0xff91959e),
      c7: new ui.Color(0xff4d5b75),
      c8: new ui.Color(0xffd9dadd),
      c9: new ui.Color(0xff253140),
      c10: new ui.Color(0xff1f2937),
      c11: new ui.Color(0xfff9746d),
      c12: new ui.Color(0xff282d33),
      c13: new ui.Color(0xff00875a),
      c14: new ui.Color(0xffffb818),
      c15: new ui.Color(0xffffffff),
      c16: new ui.Color(0xff5d1821),
      c17: new ui.Color(0xffef934d),
    });

    return StyleThemeData.DarkTheme;
  }
  public static createLightTheme(): StyleThemeData {
    StyleThemeData.LightTheme = new StyleThemeData({
      themeName: "LightTheme",
      color: new ui.Color(0xffffffff),
      textStyle: new ui.TextStyle({
        color: new ui.Color(0xff616161),
        fontFamily: "Open Sans",
        fontSize: 13.0,
      }),
      tooltipBackgroundColor: new ui.Color(0xff1f2937),
      tooltipTextColor: new ui.Color(0xffffffff),
      tTableRowTableBackgroundDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xffebeef2),
        transitions: new Map(),
      }),
      tTableRowTableBackgroundPaddingOn: ui.EdgeInsets.symmetric({
        horizontal: 0.0,
        vertical: 5.0,
        transitions: new Map(),
      }),
      tTableRowTableBackgroundTextStyleOn: new ui.TextStyle({
        color: new ui.Color(0xff000000),
        fontFamily: "Open Sans",
      }),
      tTableRowTableBackgroundConstraintsOn: new ui.BoxConstraints({
        minWidth: 80.0,
      }),
      tTableCellDefaultCellVerticalAlignmentOn:
        ui.TableCellVerticalAlignment.middle,
      tTableDefaultTableBorderOn: new ui.TableBorder({
        horizontalInside: new ui.BorderSide({
          color: new ui.Color(0xffd9d9d9),
          width: 0.5,
          style: ui.BorderStyle.solid,
        }),
        bottom: new ui.BorderSide({
          color: new ui.Color(0xffd9d9d9),
          width: 0.5,
          style: ui.BorderStyle.solid,
        }),
      }),
      tButtonButtonWithNoBorderRadiusDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xff1f2937),
        border: ui.Border.all({ color: new ui.Color(0xff1f2937), width: 1.0 }),
        transitions: new Map(),
      }),
      tButtonButtonWithNoBorderRadiusHeightOn: 35.0,
      tButtonButtonWithNoBorderRadiusConstraintsOn: new ui.BoxConstraints({
        minWidth: 110.0,
      }),
      tButtonButtonWithNoBorderRadiusTextStyleOn: new ui.TextStyle({
        color: new ui.Color(0xffffffff),
        fontWeight: ui.FontWeight.w500,
        fontSize: 14.0,
        fontFamily: "Open Sans",
      }),
      tButtonButtonWithNoBorderRadiusDecorationOnHover: new ui.BoxDecoration({
        color: new ui.Color(0xff3a485a),
        border: ui.Border.all({ color: new ui.Color(0xff3a485a), width: 1.0 }),
        transitions: new Map(),
      }),
      tButtonButtonWithNoBorderRadiusTextStyleOnHover: new ui.TextStyle({
        color: new ui.Color(0xffffffff),
        fontWeight: ui.FontWeight.w500,
        fontSize: 14.0,
        fontFamily: "Open Sans",
      }),
      tButtonButtonWithNoBorderRadiusDecorationOnFocus: new ui.BoxDecoration({
        color: new ui.Color(0xff1f2937),
        border: ui.Border.all({ color: new ui.Color(0xff007acc), width: 1.0 }),
        transitions: new Map(),
      }),
      tButtonButtonWithNoBorderRadiusTextStyleOnFocus: new ui.TextStyle({
        color: new ui.Color(0xffffffff),
        fontWeight: ui.FontWeight.w500,
        fontSize: 14.0,
        fontFamily: "Open Sans",
      }),
      tButtonPrimaryButtonDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xff1f2937),
        border: ui.Border.all({ color: new ui.Color(0xff1f2937), width: 2.0 }),
        borderRadius: ui.BorderRadius.circular(5.0),
        transitions: new Map(),
      }),
      tButtonPrimaryButtonPaddingOn: ui.EdgeInsets.all(7.0, new Map()),
      tButtonPrimaryButtonConstraintsOn: new ui.BoxConstraints({
        minWidth: 110.0,
      }),
      tButtonPrimaryButtonTextStyleOn: new ui.TextStyle({
        color: new ui.Color(0xffffffff),
        fontWeight: ui.FontWeight.w500,
        fontSize: 14.0,
        fontFamily: "Open Sans",
      }),
      tButtonPrimaryButtonDecorationOnHover: new ui.BoxDecoration({
        color: new ui.Color(0xff3a485a),
        border: ui.Border.all({ color: new ui.Color(0xff3a485a), width: 2.0 }),
        borderRadius: ui.BorderRadius.circular(5.0),
        transitions: new Map(),
      }),
      tButtonPrimaryButtonTextStyleOnHover: new ui.TextStyle({
        color: new ui.Color(0xffffffff),
        fontWeight: ui.FontWeight.w500,
        fontSize: 14.0,
        fontFamily: "Open Sans",
      }),
      tButtonPrimaryButtonDecorationOnFocus: new ui.BoxDecoration({
        color: new ui.Color(0x0),
        border: ui.Border.all({ color: new ui.Color(0xff007acc), width: 2.0 }),
        borderRadius: ui.BorderRadius.circular(5.0),
        transitions: new Map(),
      }),
      tButtonPrimaryButtonTextStyleOnFocus: new ui.TextStyle({
        color: new ui.Color(0xff1f2937),
        fontWeight: ui.FontWeight.w500,
        fontSize: 14.0,
        fontFamily: "Open Sans",
      }),
      tButtonDisabledPrimaryButtonDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xffdcdcdc),
        border: ui.Border.all({ color: new ui.Color(0xffd9d9d9), width: 2.0 }),
        borderRadius: ui.BorderRadius.circular(5.0),
        transitions: new Map(),
      }),
      tButtonDisabledPrimaryButtonPaddingOn: ui.EdgeInsets.all(7.0, new Map()),
      tButtonDisabledPrimaryButtonConstraintsOn: new ui.BoxConstraints({
        minWidth: 110.0,
      }),
      tButtonDisabledPrimaryButtonTextStyleOn: new ui.TextStyle({
        color: new ui.Color(0xffffffff),
        fontWeight: ui.FontWeight.w500,
        fontSize: 14.0,
        fontFamily: "Open Sans",
      }),
      tButtonSecondaryButtonPaddingOn: ui.EdgeInsets.all(7.0, new Map()),
      tButtonSecondaryButtonConstraintsOn: new ui.BoxConstraints({
        minWidth: 110.0,
      }),
      tButtonSecondaryButtonDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xffffffff),
        border: ui.Border.all({ width: 2.0, color: new ui.Color(0xff1f2937) }),
        borderRadius: ui.BorderRadius.circular(5.0),
        transitions: new Map(),
      }),
      tButtonSecondaryButtonTextStyleOn: new ui.TextStyle({
        color: new ui.Color(0xff1f2937),
        fontWeight: ui.FontWeight.w500,
        fontSize: 14.0,
        fontFamily: "Open Sans",
      }),
      tButtonSecondaryButtonDecorationOnHover: new ui.BoxDecoration({
        border: ui.Border.all({ width: 2.0, color: new ui.Color(0xff1f2937) }),
        borderRadius: ui.BorderRadius.circular(5.0),
        color: new ui.Color(0xffebeef2),
        transitions: new Map(),
      }),
      tButtonSecondaryButtonTextStyleOnHover: new ui.TextStyle({
        color: new ui.Color(0xff1f2937),
        fontWeight: ui.FontWeight.w500,
        fontSize: 14.0,
        fontFamily: "Open Sans",
      }),
      tButtonSecondaryButtonDecorationOnFocus: new ui.BoxDecoration({
        color: new ui.Color(0xffffffff),
        border: ui.Border.all({ color: new ui.Color(0xff007acc), width: 2.0 }),
        borderRadius: ui.BorderRadius.circular(5.0),
        transitions: new Map(),
      }),
      tButtonSecondaryButtonTextStyleOnFocus: new ui.TextStyle({
        color: new ui.Color(0xff1f2937),
        fontWeight: ui.FontWeight.w500,
        fontSize: 14.0,
        fontFamily: "Open Sans",
      }),
      tButtonAddButtonDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xff1f2937),
        border: ui.Border.all({ color: new ui.Color(0x0), width: 1.0 }),
        borderRadius: ui.BorderRadius.circular(5.0),
        transitions: new Map(),
      }),
      tButtonAddButtonTextStyleOn: new ui.TextStyle({
        color: new ui.Color(0xffffffff),
        fontWeight: ui.FontWeight.w500,
        fontSize: 14.0,
        fontFamily: "Open Sans",
      }),
      tButtonAddButtonHeightOn: 35.0,
      tButtonAddButtonPaddingOn: ui.EdgeInsets.all(7.0, new Map()),
      tButtonAddButtonConstraintsOn: new ui.BoxConstraints({ minWidth: 35.0 }),
      tButtonAddButtonDecorationOnHover: new ui.BoxDecoration({
        color: new ui.Color(0xff3a485a),
        border: ui.Border.all({ color: new ui.Color(0xff3a485a), width: 1.0 }),
        borderRadius: ui.BorderRadius.circular(5.0),
        transitions: new Map(),
      }),
      tButtonAddButtonTextStyleOnHover: new ui.TextStyle({
        color: new ui.Color(0xffffffff),
        fontWeight: ui.FontWeight.w500,
        fontSize: 14.0,
        fontFamily: "Open Sans",
      }),
      tButtonAddButtonDecorationOnFocus: new ui.BoxDecoration({
        color: new ui.Color(0xff1f2937),
        border: ui.Border.all({ color: new ui.Color(0xff007acc), width: 1.0 }),
        borderRadius: ui.BorderRadius.circular(5.0),
        transitions: new Map(),
      }),
      tButtonAddButtonTextStyleOnFocus: new ui.TextStyle({
        color: new ui.Color(0xff1f2937),
        fontWeight: ui.FontWeight.w500,
        fontSize: 14.0,
        fontFamily: "Open Sans",
      }),
      tButtonDeleteButtonDecorationOnHover: new ui.BoxDecoration({
        color: new ui.Color(0xfffc0404),
        border: ui.Border.all({ color: new ui.Color(0xfffc0404), width: 2.0 }),
        borderRadius: ui.BorderRadius.circular(5.0),
        transitions: new Map(),
      }),
      tButtonDeleteButtonTextStyleOnHover: new ui.TextStyle({
        color: new ui.Color(0xffffffff),
        fontWeight: ui.FontWeight.w500,
        fontSize: 14.0,
        fontFamily: "Open Sans",
      }),
      tButtonDeleteButtonDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xffffe1e1),
        border: ui.Border.all({ color: new ui.Color(0xfffc0404), width: 2.0 }),
        borderRadius: ui.BorderRadius.circular(5.0),
        transitions: new Map(),
      }),
      tButtonDeleteButtonPaddingOn: ui.EdgeInsets.all(7.0, new Map()),
      tButtonDeleteButtonConstraintsOn: new ui.BoxConstraints({
        minWidth: 110.0,
      }),
      tButtonDeleteButtonTextStyleOn: new ui.TextStyle({
        color: new ui.Color(0xfffc0404),
        fontWeight: ui.FontWeight.w500,
        fontSize: 14.0,
        fontFamily: "Open Sans",
      }),
      tButtonDeleteButtonDecorationOnFocus: new ui.BoxDecoration({
        color: new ui.Color(0xffffe1e1),
        border: ui.Border.all({ color: new ui.Color(0xff007acc), width: 2.0 }),
        borderRadius: ui.BorderRadius.circular(5.0),
        transitions: new Map(),
      }),
      tButtonDeleteButtonTextStyleOnFocus: new ui.TextStyle({
        color: new ui.Color(0xfffc0404),
        fontWeight: ui.FontWeight.w500,
        fontSize: 14.0,
        fontFamily: "Open Sans",
      }),
      tTextViewListTileTextFontSizeOn: 13.0,
      tTextViewListTileTextFontWeightOn: ui.FontWeight.w500,
      tTextViewListTileTextColorOn: new ui.Color(0xffffffff),
      tTextViewListTileTextOverflowOn: ui.TextOverflow.ellipsis,
      tTextViewListTileTextOnLightBackgroundFontSizeOn: 13.0,
      tTextViewListTileTextOnLightBackgroundFontWeightOn: ui.FontWeight.w500,
      tTextViewListTileTextOnLightBackgroundColorOn: new ui.Color(0xff616161),
      tTextViewBoldHeadingFontSizeOn: 30.0,
      tTextViewBoldHeadingFontWeightOn: ui.FontWeight.w700,
      tTextViewBoldHeadingColorOn: new ui.Color(0xff000000),
      tTextViewBoldHeadingPaddingOn: ui.EdgeInsets.fromLTRB(
        0.0,
        15.0,
        0.0,
        20.0,
        new Map()
      ),
      tTextViewHeadingFontSizeOn: 20.0,
      tTextViewHeadingFontWeightOn: ui.FontWeight.w600,
      tTextViewHeadingTextAlignOn: ui.TextAlign.start,
      tTextViewHeadingColorOn: new ui.Color(0xff000000),
      tTextViewParagraphHeadingFontSizeOn: 18.0,
      tTextViewParagraphHeadingFontWeightOn: ui.FontWeight.w400,
      tTextViewParagraphHeadingTextAlignOn: ui.TextAlign.start,
      tTextViewParagraphHeadingColorOn: new ui.Color(0xff000000),
      tTextViewParagraphHeadingPaddingOn: ui.EdgeInsets.symmetric({
        horizontal: 0.0,
        vertical: 20.0,
        transitions: new Map(),
      }),
      tCheckboxActiveCheckboxActiveColorOn: new ui.Color(0xff1f2937),
      tIconButtonIconButtonDefaultColorOn: new ui.Color(0xff3a485a),
      tIconButtonIconButtonDefaultHoverColorOn: new ui.Color(0xff007acc),
      tIconViewIconViewDefaultColorOn: new ui.Color(0xff3a485a),
      tIconViewIconViewDefaultColorOnHover: new ui.Color(0xff007acc),
      tIconViewIconViewDefaultColorOnFocus: new ui.Color(0xff007acc),
      tTextViewTitleFontSizeOn: 15.0,
      tTextViewTitleColorOn: new ui.Color(0xff000000),
      tTextViewTitleFontWeightOn: ui.FontWeight.w600,
      tTextViewTitleTextAlignOn: ui.TextAlign.start,
      tRowSuccessBackgroundDecorationOn: new ui.BoxDecoration({
        borderRadius: ui.BorderRadius.circular(3.0),
        color: new ui.Color(0xff00875a),
        border: ui.Border.all({ color: new ui.Color(0xffd9d9d9), width: 1.5 }),
        transitions: new Map(),
      }),
      tRowSuccessBackgroundPaddingOn: ui.EdgeInsets.symmetric({
        horizontal: 10.0,
        vertical: 5.0,
        transitions: new Map(),
      }),
      tTextViewSuccessErrorTextFontSizeOn: 15.0,
      tTextViewSuccessErrorTextTextAlignOn: ui.TextAlign.start,
      tTextViewSuccessErrorTextColorOn: new ui.Color(0xffffffff),
      tTextViewErrorMessageColorOn: new ui.Color(0xfffc0404),
      tTextViewErrorMessageFontSizeOn: 12.0,
      tTextViewErrorMessageTextAlignOn: ui.TextAlign.start,
      tTextViewListTextFontSizeOn: 13.0,
      tTextViewListTextColorOn: new ui.Color(0xff000000),
      tTextViewListTextTextAlignOn: ui.TextAlign.start,
      tTextViewListTextOverflowOn: ui.TextOverflow.ellipsis,
      tTextViewLabelTextColorOn: new ui.Color(0xff000000),
      tTextViewLabelTextTextAlignOn: ui.TextAlign.start,
      tTextViewLabelTextFontSizeOn: 13.0,
      tTextViewLabelTextFontWeightOn: ui.FontWeight.w600,
      tBaseBackgroundColorDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xffebeef2),
        transitions: new Map(),
      }),
      tBaseBackgroundColorColumnDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xffebeef2),
        transitions: new Map(),
      }),
      tBaseBackgroundColorColumnPaddingOn: ui.EdgeInsets.fromLTRB(
        20.0,
        20.0,
        0.0,
        20.0,
        new Map()
      ),
      tTextViewParagraphTextFontSizeOn: 13.0,
      tTextViewParagraphTextFontWeightOn: ui.FontWeight.w400,
      tTextViewParagraphTextColorOn: new ui.Color(0xff888888),
      tTextViewColoredTextColorOn: new ui.Color(0xff007acc),
      tTextViewColoredTextFontSizeOn: 13.0,
      tTextViewColoredTextTextDecorationOnHover: ui.TextDecoration.underline,
      tTextViewParagraphCenterFontSizeOn: 13.0,
      tTextViewParagraphCenterTextAlignOn: ui.TextAlign.center,
      tTextViewParagraphCenterColorOn: new ui.Color(0xff888888),
      tTextViewParagraphCenterPaddingOn: ui.EdgeInsets.zero,
      tTextViewTextOverFlowFontSizeOn: 13.0,
      tTextViewTextOverFlowMaxLinesOn: 2,
      tTextViewTextOverFlowTextAlignOn: ui.TextAlign.center,
      tTextViewTextOverFlowOverflowOn: ui.TextOverflow.ellipsis,
      tInputFieldNormalInputfieldHeightOn: 35.0,
      tInputFieldNormalInputfieldWidthOn: 400.0,
      tInputFieldNormalInputfieldBackgroundColorOn: new ui.Color(0xffffffff),
      tInputFieldNormalInputfieldCornerRadiusOn: 0.0,
      tInputFieldNormalInputfieldCursorColorOn: new ui.Color(0xff007acc),
      tInputFieldNormalInputfieldInActiveColorOn: new ui.Color(0xffd9d9d9),
      tInputFieldNormalInputfieldPlaceHolderColorOn: new ui.Color(0xff888888),
      tInputFieldNormalInputfieldStyleOn: new ui.TextStyle({
        color: new ui.Color(0xff000000),
        fontFamily: "Open Sans",
      }),
      tInputFieldSmallNormalInputfieldHeightOn: 35.0,
      tInputFieldSmallNormalInputfieldWidthOn: 360.0,
      tInputFieldSmallNormalInputfieldBackgroundColorOn: new ui.Color(
        0xffffffff
      ),
      tInputFieldSmallNormalInputfieldCornerRadiusOn: 3.0,
      tInputFieldSmallNormalInputfieldCursorColorOn: new ui.Color(0xff007acc),
      tInputFieldSmallNormalInputfieldInActiveColorOn: new ui.Color(0xffd9d9d9),
      tInputFieldSmallNormalInputfieldPlaceHolderColorOn: new ui.Color(
        0xff888888
      ),
      tInputFieldSmallNormalInputfieldStyleOn: new ui.TextStyle({
        color: new ui.Color(0xff000000),
        fontFamily: "Open Sans",
      }),
      tInputFieldTestDataInputfieldHeightOn: 35.0,
      tInputFieldTestDataInputfieldWidthOn: 150.0,
      tInputFieldTestDataInputfieldBackgroundColorOn: new ui.Color(0xffffffff),
      tInputFieldTestDataInputfieldCornerRadiusOn: 5.0,
      tInputFieldTestDataInputfieldCursorColorOn: new ui.Color(0xff007acc),
      tInputFieldTestDataInputfieldStyleOn: new ui.TextStyle({
        color: new ui.Color(0xff000000),
        fontFamily: "Open Sans",
      }),
      tInputFieldDisabledInputfieldWidthOn: 400.0,
      tInputFieldDisabledInputfieldHeightOn: 35.0,
      tInputFieldDisabledInputfieldBackgroundColorOn: new ui.Color(0xffdcdcdc),
      tInputFieldDisabledInputfieldStyleOn: new ui.TextStyle({
        color: new ui.Color(0xff000000),
        fontFamily: "Open Sans",
      }),
      tInputFieldDisabledInputfieldDisableOn: true,
      tInputFieldDisabledInputfieldDecorationOn: new ui.BoxDecoration({
        border: ui.Border.all({ color: new ui.Color(0xffd9d9d9) }),
        borderRadius: ui.BorderRadius.circular(5.0),
        transitions: new Map(),
      }),
      tInputFieldSmallDisabledInputfieldWidthOn: 360.0,
      tInputFieldSmallDisabledInputfieldHeightOn: 35.0,
      tInputFieldSmallDisabledInputfieldBackgroundColorOn: new ui.Color(
        0xffdcdcdc
      ),
      tInputFieldSmallDisabledInputfieldStyleOn: new ui.TextStyle({
        color: new ui.Color(0xff000000),
        fontFamily: "Open Sans",
      }),
      tInputFieldSmallDisabledInputfieldDisableOn: true,
      tInputFieldSmallDisabledInputfieldDecorationOn: new ui.BoxDecoration({
        border: ui.Border.all({ color: new ui.Color(0xffd9d9d9) }),
        borderRadius: ui.BorderRadius.circular(5.0),
        transitions: new Map(),
      }),
      tInputFieldSearchInputfieldInActiveColorOn: new ui.Color(0xffffffff),
      tInputFieldSearchInputfieldPlaceHolderColorOn: new ui.Color(0xff888888),
      tInputFieldSearchInputfieldActiveColorOn: new ui.Color(0xffffffff),
      tInputFieldSearchInputfieldPaddingOn: ui.EdgeInsets.fromLTRB(
        0.0,
        4.0,
        2.0,
        4.0,
        new Map()
      ),
      tInputFieldDescriptionInputfieldHeightOn: 90.0,
      tInputFieldDescriptionInputfieldWidthOn: 400.0,
      tInputFieldDescriptionInputfieldCornerRadiusOn: 5.0,
      tInputFieldDescriptionInputfieldBackgroundColorOn: new ui.Color(
        0xffffffff
      ),
      tInputFieldDescriptionInputfieldPlaceHolderColorOn: new ui.Color(
        0xff888888
      ),
      tInputFieldDescriptionInputfieldStyleOn: new ui.TextStyle({
        color: new ui.Color(0xff000000),
        fontFamily: "Open Sans",
      }),
      tBasePanelColorWithBorderDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xff1f2937),
        border: new ui.Border({
          right: new ui.BorderSide({
            color: new ui.Color(0xffd9d9d9),
            width: 1.0,
          }),
        }),
        transitions: new Map(),
      }),
      tTextViewDropDownBuilderTextColorOn: new ui.Color(0xff616161),
      tTextViewDropDownBuilderTextPaddingOn: ui.EdgeInsets.fromLTRB(
        5.0,
        4.0,
        0.0,
        4.0,
        new Map()
      ),
      tDropDownRoundRadiusDropDownHeightOn: 35.0,
      tDropDownRoundRadiusDropDownOnHoverColorOn: new ui.Color(0xffdde2e8),
      tDropDownRoundRadiusDropDownPlaceHolderColorOn: new ui.Color(0xff888888),
      tDropDownRoundRadiusDropDownDropDownDecorationOn: new ui.BoxDecoration({
        border: ui.Border.all({ color: new ui.Color(0xffd9d9d9), width: 1.0 }),
        borderRadius: ui.BorderRadius.circular(3.0),
        color: new ui.Color(0xffffffff),
        transitions: new Map(),
      }),
      tDropDownRoundRadiusDropDownViewDecorationOn: new ui.BoxDecoration({
        border: new ui.Border({
          right: new ui.BorderSide({
            color: new ui.Color(0xffd9d9d9),
            width: 1.0,
          }),
          left: new ui.BorderSide({
            color: new ui.Color(0xffd9d9d9),
            width: 1.0,
          }),
          bottom: new ui.BorderSide({
            color: new ui.Color(0xffd9d9d9),
            width: 1.0,
          }),
        }),
        color: new ui.Color(0xffffffff),
        transitions: new Map(),
      }),
      tBasePrimaryListTileDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xff1f2937),
        border: new ui.Border({
          bottom: new ui.BorderSide({ color: new ui.Color(0x0), width: 2.0 }),
        }),
        transitions: new Map(),
      }),
      tBasePrimaryListTileTextStyleOn: new ui.TextStyle({
        color: new ui.Color(0xffffffff),
        fontFamily: "Open Sans",
      }),
      tBasePrimaryListTileDecorationOnHover: new ui.BoxDecoration({
        color: new ui.Color(0xff3a485a),
        border: new ui.Border({
          bottom: new ui.BorderSide({ color: new ui.Color(0x0), width: 2.0 }),
        }),
        transitions: new Map(),
      }),
      tBasePrimaryListTileTextStyleOnHover: new ui.TextStyle({
        color: new ui.Color(0xffffffff),
        fontFamily: "Open Sans",
      }),
      tBasePrimaryListTileDecorationOnFocus: new ui.BoxDecoration({
        border: ui.Border.all({ color: new ui.Color(0xff007acc), width: 1.0 }),
        transitions: new Map(),
      }),
      tBasePrimaryListTileDecorationOnSelected: new ui.BoxDecoration({
        color: new ui.Color(0xff3a485a),
        border: new ui.Border({
          bottom: new ui.BorderSide({
            color: new ui.Color(0xffffffff),
            width: 2.0,
          }),
        }),
        transitions: new Map(),
      }),
      tBasePrimaryListTileTextStyleOnSelected: new ui.TextStyle({
        color: new ui.Color(0xffffffff),
        fontFamily: "Open Sans",
      }),
      tBasePrimaryListTileDecorationOnHoverSelected: new ui.BoxDecoration({
        color: new ui.Color(0xff3a485a),
        border: new ui.Border({
          bottom: new ui.BorderSide({
            color: new ui.Color(0xffffffff),
            width: 1.0,
          }),
        }),
        transitions: new Map(),
      }),
      tBasePrimaryListTileTextStyleOnHoverSelected: new ui.TextStyle({
        color: new ui.Color(0xffffffff),
        fontFamily: "Open Sans",
      }),
      tBaseExpEditorStyleDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xffffffff),
        transitions: new Map(),
      }),
      tBaseDarkBackgroundDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xff1f2937),
        transitions: new Map(),
      }),
      tBaseDarkBackgroundTextStyleOn: new ui.TextStyle({
        color: new ui.Color(0xffffffff),
        fontFamily: "Open Sans",
      }),
      tContainerLinearGradiantWidthOn: 100.0,
      tContainerLinearGradiantHeightOn: 100.0,
      tContainerLinearGradiantDecorationOn: new ui.BoxDecoration({
        gradient: new ui.LinearGradient({
          colors: [new ui.Color(0xff616161), new ui.Color(0xffffffff)],
        }),
        transitions: new Map(),
      }),
      tBaseSweepGradiantWidthOn: 100.0,
      tBaseSweepGradiantHeightOn: 100.0,
      tBaseSweepGradiantDecorationOn: new ui.BoxDecoration({
        gradient: new ui.SweepGradient({
          colors: [new ui.Color(0xff616161), new ui.Color(0xffffffff)],
        }),
        transitions: new Map(),
      }),
      tContainerRadiualGradiantWidthOn: 100.0,
      tContainerRadiualGradiantHeightOn: 100.0,
      tContainerRadiualGradiantDecorationOn: new ui.BoxDecoration({
        gradient: new ui.RadialGradient({
          colors: [new ui.Color(0xff616161), new ui.Color(0xffffffff)],
        }),
        transitions: new Map(),
      }),
      tButtonUnderlineButtonTextStyleOn: new ui.TextStyle({
        color: new ui.Color(0xff007acc),
        fontSize: 13.0,
        fontWeight: ui.FontWeight.w600,
        fontFamily: "Open Sans",
      }),
      tButtonUnderlineButtonTextStyleOnHover: new ui.TextStyle({
        decoration: ui.TextDecoration.underline,
        color: new ui.Color(0xff007acc),
        fontSize: 13.0,
        fontWeight: ui.FontWeight.w600,
        fontFamily: "Open Sans",
      }),
      tButtonUnderlineButtonTextStyleOnFocusHover: new ui.TextStyle({
        decoration: ui.TextDecoration.underline,
        color: new ui.Color(0xff007acc),
        fontSize: 13.0,
        fontWeight: ui.FontWeight.w600,
        fontFamily: "Open Sans",
      }),
      tButtonUnderlineButtonDecorationOnFocus: new ui.BoxDecoration({
        color: new ui.Color(0xffffffff),
        border: ui.Border.all({ width: 1.0, color: new ui.Color(0xff007acc) }),
        transitions: new Map(),
      }),
      tButtonUnderlineButtonTextStyleOnFocus: new ui.TextStyle({
        decoration: ui.TextDecoration.underline,
        color: new ui.Color(0xff007acc),
        fontSize: 13.0,
        fontWeight: ui.FontWeight.w600,
        fontFamily: "Open Sans",
      }),
      tButtonBoldUnderlineButtonTextStyleOn: new ui.TextStyle({
        color: new ui.Color(0xff007acc),
        fontSize: 20.0,
        fontWeight: ui.FontWeight.w500,
        fontFamily: "Open Sans",
      }),
      tButtonBoldUnderlineButtonTextStyleOnHover: new ui.TextStyle({
        decoration: ui.TextDecoration.underline,
        color: new ui.Color(0xff007acc),
        fontSize: 20.0,
        fontWeight: ui.FontWeight.w500,
        fontFamily: "Open Sans",
      }),
      tButtonBoldUnderlineButtonTextStyleOnFocus: new ui.TextStyle({
        decoration: ui.TextDecoration.underline,
        color: new ui.Color(0xff007acc),
        fontSize: 20.0,
        fontWeight: ui.FontWeight.w500,
        fontFamily: "Open Sans",
      }),
      tButtonBoldUnderlineButtonTextStyleOnFocusHover: new ui.TextStyle({
        decoration: ui.TextDecoration.underline,
        color: new ui.Color(0xff007acc),
        fontSize: 20.0,
        fontWeight: ui.FontWeight.w500,
        fontFamily: "Open Sans",
      }),
      tSearchComponentSearchFieldDecorationOn: new ui.BoxDecoration({
        border: ui.Border.all({ color: new ui.Color(0xffd9d9d9), width: 1.0 }),
        borderRadius: ui.BorderRadius.circular(10.0),
        transitions: new Map(),
      }),
      tSearchComponentSearchFieldDecorationOnFocus: new ui.BoxDecoration({
        border: ui.Border.all({ color: new ui.Color(0xffd9d9d9), width: 1.0 }),
        borderRadius: ui.BorderRadius.circular(10.0),
        transitions: new Map(),
      }),
      tCheckboxWithTextActiveCheckboxWithTextActiveColorOn: new ui.Color(
        0xff1f2937
      ),
      tDoubleInputFieldTestDoubleInputFieldHeightOn: 35.0,
      tDoubleInputFieldTestDoubleInputFieldWidthOn: 150.0,
      tDoubleInputFieldTestDoubleInputFieldBackgroundColorOn: new ui.Color(
        0xffffffff
      ),
      tDoubleInputFieldTestDoubleInputFieldCornerRadiusOn: 5.0,
      tIntegerInputFieldTestIntegerInputFieldHeightOn: 35.0,
      tIntegerInputFieldTestIntegerInputFieldWidthOn: 150.0,
      tIntegerInputFieldTestIntegerInputFieldBackgroundColorOn: new ui.Color(
        0xffffffff
      ),
      tIntegerInputFieldTestIntegerInputFieldCornerRadiusOn: 5.0,
      tAutoSearchTextWithBuilderAutoRoundRadiusDropDownHeightOn: 35.0,
      tAutoSearchTextWithBuilderAutoRoundRadiusDropDownViewDecorationOn:
        new ui.BoxDecoration({
          border: new ui.Border({
            right: new ui.BorderSide({
              color: new ui.Color(0xffd9d9d9),
              width: 1.0,
            }),
            left: new ui.BorderSide({
              color: new ui.Color(0xffd9d9d9),
              width: 1.0,
            }),
            bottom: new ui.BorderSide({
              color: new ui.Color(0xffd9d9d9),
              width: 1.0,
            }),
          }),
          color: new ui.Color(0xffffffff),
          transitions: new Map(),
        }),
      tAutoSearchTextWithBuilderAutoRoundRadiusDropDownDecorationOn:
        new ui.BoxDecoration({
          color: new ui.Color(0xffffffff),
          border: ui.Border.all({
            color: new ui.Color(0xffd9d9d9),
            width: 1.0,
          }),
          borderRadius: ui.BorderRadius.circular(3.0),
          transitions: new Map(),
        }),
      tInputFieldInputBasicBackgroundColorOn: new ui.Color(0xffffffff),
      tInputFieldInputBasicCornerRadiusOn: 3.0,
      tInputFieldInputBasicDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xffffffff),
        border: ui.Border.all({ width: 1.0, color: new ui.Color(0xffd9d9d9) }),
        borderRadius: ui.BorderRadius.circular(3.0),
        transitions: new Map(),
      }),
      tInputFieldFixedInputFieldBackgroundColorOn: new ui.Color(0xffffffff),
      tInputFieldFixedInputFieldCornerRadiusOn: 3.0,
      tInputFieldFixedInputFieldDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xffffffff),
        borderRadius: ui.BorderRadius.circular(3.0),
        transitions: new Map(),
      }),
      tBaseCardDecorationOn: new ui.BoxDecoration({
        border: ui.Border.all({ color: new ui.Color(0xffd9d9d9), width: 2.0 }),
        boxShadow: [
          new ui.BoxShadow({
            color: new ui.Color(0xffffffff),
            blurRadius: 1.0,
            spreadRadius: 2.0,
          }),
        ],
        borderRadius: ui.BorderRadius.circular(3.0),
        transitions: new Map(),
      }),
      tBaseDefaultPopUpDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xffffffff),
        borderRadius: ui.BorderRadius.circular(2.0),
        boxShadow: [
          new ui.BoxShadow({
            color: new ui.Color(0x32000000),
            blurRadius: 5.0,
          }),
        ],
        transitions: new Map(),
      }),
      tTextViewCollapsableHeaderTextColorOn: new ui.Color(0xff000000),
      tTextViewCollapsableHeaderTextFontSizeOn: 16.0,
      tTextViewCollapsableHeaderTextFontWeightOn: ui.FontWeight.w600,
      tBaseToolTipDecorationDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xff1f2937),
        border: ui.Border.all({ color: new ui.Color(0xffd9d9d9), width: 1.0 }),
        borderRadius: ui.BorderRadius.circular(3.0),
        transitions: new Map(),
      }),
      tBaseToolTipDecorationPaddingOn: ui.EdgeInsets.all(12.0, new Map()),
      tBaseToolTipDecorationTextStyleOn: new ui.TextStyle({
        color: new ui.Color(0xffffffff),
        fontSize: 10.0,
        fontFamily: "Open Sans",
      }),
      tTableRowTableRowHeadingDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xffebeef2),
        border: new ui.Border({
          bottom: new ui.BorderSide({ color: new ui.Color(0xffd9d9d9) }),
        }),
        borderRadius: ui.BorderRadiusExt.only({
          topLeft: ui.RadiusExt.elliptical({ x: 3.0, y: 3.0 }),
          topRight: ui.RadiusExt.elliptical({ x: 3.0, y: 3.0 }),
        }),
        transitions: new Map(),
      }),
      tBaseBackgroundColorColumn2DecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xffffffff),
        transitions: new Map(),
      }),
      tBaseBackgroundColorColumn2PaddingOn: ui.EdgeInsets.symmetric({
        horizontal: 0.0,
        vertical: 5.0,
        transitions: new Map(),
      }),
      tEditTextFieldNormalEditTextFieldHeightOn: 35.0,
      tEditTextFieldNormalEditTextFieldWidthOn: 400.0,
      tEditTextFieldNormalEditTextFieldDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xffffffff),
        border: ui.Border.all({ color: new ui.Color(0xffd9d9d9), width: 1.0 }),
        borderRadius: ui.BorderRadius.circular(5.0),
        transitions: new Map(),
      }),
      tCheckboxWitheLabelActiveCheckboxWithLabelActiveColorOn: new ui.Color(
        0xff1f2937
      ),
      tContainerDropAreaHeightOn: 10.0,
      tContainerDropAreaHeightOnHover: 20.0,
      tContainerDropAreaDecorationOnHover: new ui.BoxDecoration({
        color: new ui.Color(0xffffffff),
        border: ui.Border.all({ width: 1.0, color: new ui.Color(0xff262c34) }),
        transitions: new Map(),
      }),
      tBaseSelectedTabContainerHeightOn: 2.5,
      tBaseSelectedTabContainerWidthOn: 35.0,
      tBaseSelectedTabContainerDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xff1f2937),
        borderRadius: ui.BorderRadius.circular(5.0),
        transitions: new Map(),
      }),
      tTextViewTabsFontSizeOn: 14.0,
      tTextViewTabsFontWeightOn: ui.FontWeight.w600,
      tRowChatBoxDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0x0),
        border: ui.Border.all({ color: new ui.Color(0x0), width: 1.0 }),
        borderRadius: ui.BorderRadius.circular(50.0),
        transitions: new Map(),
      }),
      tRowChatBoxPaddingOn: ui.EdgeInsets.all(15.0, new Map()),
      tColumnTemplateCardPaddingOn: ui.EdgeInsets.all(5.0, new Map()),
      tColumnTemplateCardDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xffffffff),
        border: ui.Border.all({ color: new ui.Color(0xffdcdcdc), width: 1.0 }),
        borderRadius: ui.BorderRadius.circular(3.0),
        transitions: new Map(),
      }),
      tButtonBtnLinkDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xffffffff),
        border: ui.Border.all({ color: new ui.Color(0xffffffff), width: 1.0 }),
        borderRadius: ui.BorderRadius.circular(3.0),
        transitions: new Map(),
      }),
      tButtonBtnLinkTextStyleOn: new ui.TextStyle({
        decoration: ui.TextDecoration.underline,
        color: new ui.Color(0xff0d6efd),
        fontFamily: "Open Sans",
      }),
      tButtonBtnLinkTextStyleOnHover: new ui.TextStyle({
        color: new ui.Color(0xff0a58ca),
        fontFamily: "Open Sans",
      }),
      tTextViewHeadlineThreeFontSizeOn: 10.0,
      tTextViewHeadlineThreeFontWeightOn: ui.FontWeight.bold,
      tTextViewLabelColorOn: new ui.Color(0xff00875a),
      tTextViewLabelTextAlignOn: ui.TextAlign.start,
      tTextViewLabelMarginOn: ui.EdgeInsets.symmetric({
        horizontal: 0.0,
        vertical: 5.0,
        transitions: new Map(),
      }),
      tButtonOutlineButtonDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xffffffff),
        border: ui.Border.all({ color: new ui.Color(0xffdcdcdc), width: 1.0 }),
        borderRadius: ui.BorderRadius.circular(3.0),
        transitions: new Map(),
      }),
      tButtonOutlineButtonTextStyleOn: new ui.TextStyle({
        fontFamily: "Open Sans",
        fontSize: 16.0,
      }),
      tButtonOutlineButtonPaddingOn: ui.EdgeInsets.all(5.0, new Map()),
      tTextViewErrorLabelColorOn: new ui.Color(0xffe71306),
      tTextViewErrorLabelFontFamilyOn: "Open Sans",
      tTextViewErrorLabelFontSizeOn: 14.0,
      tTextViewErrorLabelMarginOn: ui.EdgeInsets.fromLTRB(
        0.0,
        5.0,
        0.0,
        0.0,
        new Map()
      ),
      tButtonNewResponceOptionButtonDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xffffffff),
        border: ui.Border.all({ color: new ui.Color(0xffffffff), width: 1.0 }),
        borderRadius: ui.BorderRadius.circular(3.0),
        transitions: new Map(),
      }),
      tButtonNewResponceOptionButtonTextStyleOn: new ui.TextStyle({
        color: new ui.Color(0xff0d6efd),
        fontFamily: "Open Sans",
      }),
      tButtonNewResponceOptionButtonTextStyleOnHover: new ui.TextStyle({
        decoration: ui.TextDecoration.underline,
        color: new ui.Color(0xff0a58ca),
        fontFamily: "Open Sans",
      }),
      tButtonPrimaryNewDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xff0f6cbd),
        border: ui.Border.all({ color: new ui.Color(0xff0f6cbd), width: 1.0 }),
        borderRadius: ui.BorderRadius.circular(3.0),
        transitions: new Map(),
      }),
      tButtonPrimaryNewPaddingOn: ui.EdgeInsets.all(10.0, new Map()),
      tButtonPrimaryNewTextStyleOn: new ui.TextStyle({
        fontFamily: "Open Sans",
        fontSize: 16.0,
        fontWeight: ui.FontWeight.w500,
        color: new ui.Color(0xffffffff),
      }),
      tButtonPrimaryNewDecorationOnHover: new ui.BoxDecoration({
        color: new ui.Color(0xff1f86df),
        border: ui.Border.all({ color: new ui.Color(0xff0f6cbd), width: 1.0 }),
        borderRadius: ui.BorderRadius.circular(3.0),
        transitions: new Map(),
      }),
      tButtonPrimaryNewPaddingOnHover: ui.EdgeInsets.all(10.0, new Map()),
      tButtonPrimaryNewTextStyleOnHover: new ui.TextStyle({
        fontFamily: "Open Sans",
        fontSize: 16.0,
        fontWeight: ui.FontWeight.w500,
        color: new ui.Color(0xffffffff),
      }),
      tButtonResponceOptionButtonPaddingOn: ui.EdgeInsets.all(3.0, new Map()),
      tButtonResponceOptionButtonDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xffffffff),
        border: ui.Border.all({ color: new ui.Color(0xff0f6cbd), width: 1.0 }),
        borderRadius: ui.BorderRadius.circular(3.0),
        transitions: new Map(),
      }),
      tButtonResponceOptionButtonTextStyleOn: new ui.TextStyle({
        fontFamily: "Open Sans",
        fontSize: 10.0,
        color: new ui.Color(0xff0f6cbd),
      }),
      tButtonResponceOptionButtonDecorationOnHover: new ui.BoxDecoration({
        color: new ui.Color(0xff0f6cbd),
        border: ui.Border.all({ color: new ui.Color(0xff0f6cbd), width: 1.0 }),
        borderRadius: ui.BorderRadius.circular(3.0),
        transitions: new Map(),
      }),
      tButtonResponceOptionButtonPaddingOnHover: ui.EdgeInsets.all(
        3.0,
        new Map()
      ),
      tButtonResponceOptionButtonTextStyleOnHover: new ui.TextStyle({
        fontFamily: "Open Sans",
        fontSize: 10.0,
        color: new ui.Color(0xffffffff),
      }),
      tButtonSecondaryDecorationOn: new ui.BoxDecoration({
        border: ui.Border.all({ color: new ui.Color(0xff13aed9), width: 1.0 }),
        borderRadius: ui.BorderRadius.circular(3.0),
        color: new ui.Color(0xffffffff),
        transitions: new Map(),
      }),
      tButtonSecondaryPaddingOn: ui.EdgeInsets.all(7.0, new Map()),
      tButtonSecondaryConstraintsOn: new ui.BoxConstraints({ minHeight: 30.0 }),
      tButtonSecondaryTextStyleOn: new ui.TextStyle({
        color: new ui.Color(0xff46b4f1),
        fontFamily: "Open Sans",
      }),
      tButtonSecondaryDecorationOnHover: new ui.BoxDecoration({
        border: ui.Border.all({ color: new ui.Color(0xff13aed9), width: 1.0 }),
        borderRadius: ui.BorderRadius.circular(3.0),
        color: new ui.Color(0xffdcdcdc),
        transitions: new Map(),
      }),
      tButtonSecondaryPaddingOnHover: ui.EdgeInsets.all(7.0, new Map()),
      tButtonSecondaryConstraintsOnHover: new ui.BoxConstraints({
        minHeight: 30.0,
      }),
      tButtonSecondaryTextStyleOnHover: new ui.TextStyle({
        color: new ui.Color(0xff46b4f1),
        fontFamily: "Open Sans",
      }),
      tButtonSecondaryNewPaddingOn: ui.EdgeInsets.all(10.0, new Map()),
      tButtonSecondaryNewDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xffffffff),
        border: ui.Border.all({ color: new ui.Color(0xff0f6cbd), width: 1.0 }),
        borderRadius: ui.BorderRadius.circular(3.0),
        transitions: new Map(),
      }),
      tButtonSecondaryNewTextStyleOn: new ui.TextStyle({
        fontFamily: "Open Sans",
        fontSize: 16.0,
        fontWeight: ui.FontWeight.w500,
        color: new ui.Color(0xff0f6cbd),
      }),
      tButtonSecondaryNewDecorationOnHover: new ui.BoxDecoration({
        color: new ui.Color(0xfff3f6f9),
        border: ui.Border.all({ color: new ui.Color(0xff0f6cbd), width: 1.0 }),
        borderRadius: ui.BorderRadius.circular(3.0),
        transitions: new Map(),
      }),
      tButtonSecondaryNewPaddingOnHover: ui.EdgeInsets.all(10.0, new Map()),
      tButtonSecondaryNewTextStyleOnHover: new ui.TextStyle({
        fontFamily: "Open Sans",
        fontSize: 16.0,
        fontWeight: ui.FontWeight.w500,
        color: new ui.Color(0xff0f6cbd),
      }),
      tTextViewTableCellTextFontSizeOn: 16.0,
      tTextViewTableCellTextColorOn: new ui.Color(0xff000000),
      tTextViewTableCellTextFontFamilyOn: "Open Sans",
      tTextViewTableHeaderFontSizeOn: 16.0,
      tTextViewTableHeaderColorOn: new ui.Color(0xff000000),
      tTextViewTableHeaderFontFamilyOn: "Open Sans",
      tTableRowTableRowOnebgDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xfff3f6f9),
        border: new ui.Border({
          bottom: new ui.BorderSide({
            color: new ui.Color(0xff0f6cbd),
            width: 0.5,
            style: ui.BorderStyle.solid,
          }),
        }),
        transitions: new Map(),
      }),
      tTableRowTableRowOnebgPaddingOn: ui.EdgeInsets.all(10.0, new Map()),
      tTableRowTableRowTwobgDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xffffffff),
        border: new ui.Border({
          bottom: new ui.BorderSide({
            color: new ui.Color(0xff0f6cbd),
            width: 0.5,
            style: ui.BorderStyle.solid,
          }),
        }),
        transitions: new Map(),
      }),
      tTableRowTableRowTwobgPaddingOn: ui.EdgeInsets.all(10.0, new Map()),
      c1: new ui.Color(0xff616161),
      c2: new ui.Color(0xffffffff),
      c3: new ui.Color(0xff1f2937),
      c4: new ui.Color(0xff3a485a),
      c5: new ui.Color(0xff007acc),
      c6: new ui.Color(0xff000000),
      c7: new ui.Color(0xffd9d9d9),
      c8: new ui.Color(0xff888888),
      c9: new ui.Color(0xffdde2e8),
      c10: new ui.Color(0xffebeef2),
      c11: new ui.Color(0xfffc0404),
      c12: new ui.Color(0xffdcdcdc),
      c13: new ui.Color(0xff00875a),
      c14: new ui.Color(0xffffb818),
      c15: new ui.Color(0xffffffff),
      c16: new ui.Color(0xffffe1e1),
      c17: new ui.Color(0xffef934d),
    });

    return StyleThemeData.LightTheme;
  }
}

interface ThemeWrapperProps {
  child: ReactNode;
}

class _ThemeWrapper extends React.Component<ThemeWrapperProps> {
  public render(): React.ReactNode {
    DomUtils.loadTheme(StyleThemeData.current.themeName);

    return React.createElement(
      BuildContext.Provider,
      { value: { ...this.context, theme: StyleThemeData.current } },
      this.props.child
    );
  }
}
export default function ThemeWrapper(props: ThemeWrapperProps) {
  return React.createElement(_ThemeWrapper, props);
}

export const ThemeContext = React.createContext<StyleThemeData>(null);
